import React, { createContext, useContext, useState, useEffect } from 'react';

// Traductions complètes pour toutes les langues
const translations = {
  fr: {
    // Navbar
    nav_home: 'Accueil',
    nav_how_it_works: 'Comment ça marche',
    nav_services: 'Services',
    nav_contact: 'Contact',
    nav_login: 'Connexion',
    nav_register: "S'inscrire",
    nav_dashboard: 'Mon Espace',
    nav_logout: 'Déconnexion',
    
    // Landing Page
    hero_badge: 'Disponible en France, en Europe et en Afrique du Nord',
    hero_title_1: 'CONVOYAGE DE VÉHICULES',
    hero_title_2: 'ET TRANSPORT MARCHANDISE',
    hero_subtitle: 'La plateforme tout-en-un pour organiser vos convoyages de véhicules et transports de marchandises en quelques clics. Rapide, sécurisé, traçable.',
    hero_cta_quote: 'Obtenir mon devis gratuit',
    hero_cta_driver: 'Devenir conducteur',
    register_hero_subtitle: 'Rejoignez des milliers de clients et conducteurs qui font confiance à ConvoyageOS pour leurs missions de transport.',
    login_hero_subtitle: 'Suivez vos missions, payez en ligne et retrouvez tous vos documents depuis votre espace personnel.',

    
    stats_missions: 'Missions réalisées',
    stats_satisfaction: 'Clients satisfaits',
    stats_insurance: 'Assurance incluse',
    stats_support: 'Support dédié',
    
    // Dashboard revenue
    dashboard_revenue: 'Revenus',
    dashboard_welcome: 'Bienvenue',
    
    services_title: 'Nos Solutions de Transport',
    services_subtitle: 'Que ce soit pour une voiture ou des marchandises, nous avons la solution adaptée à vos besoins.',
    
    service_vehicle_title: 'CONVOYAGE DE VÉHICULE',
    service_vehicle_desc: 'Déplacement de votre véhicule (voiture, utilitaire, moto) par un chauffeur professionnel certifié. Idéal pour les achats à distance, les déménagements ou les flottes d\'entreprise.',
    service_vehicle_feature_1: 'Assurance tous risques incluse',
    service_vehicle_feature_2: 'État des lieux digitalisé (PDF)',
    service_vehicle_feature_3: 'Couverture Europe & Maghreb',
    service_vehicle_cta: 'Simuler un tarif véhicule',
    
    service_freight_title: 'TRANSPORT DE MARCHANDISE',
    service_freight_desc: 'Logistique complète pour vos envois vers l\'Algérie, le Maroc et la Tunisie. Nous gérons le transport, le ferry et les formalités administratives.',
    service_freight_feature_1: 'Gestion des douanes simplifiée',
    service_freight_feature_2: 'Délais garantis et suivi live',
    service_freight_feature_3: 'Transport sécurisé porte-à-porte',
    service_freight_cta: 'Demander un devis fret',
    
    feature_title_1: 'GÉREZ TOUT DEPUIS',
    feature_title_2: 'VOTRE ESPACE CLIENT',
    feature_desc: 'Plus de papiers, plus d\'appels interminables. Convoyageos digitalise 100% du processus. Suivez vos missions, payez en ligne, signez vos contrats et retrouvez vos factures au même endroit.',
    feature_step_1: 'Devis Instantané',
    feature_step_1_desc: 'Algorithme de prix intelligent basé sur la distance et le véhicule.',
    feature_step_2: 'Signature Électronique',
    feature_step_2_desc: 'Contrats générés automatiquement et signés en ligne.',
    feature_step_3: 'Paiement Sécurisé',
    feature_step_3_desc: 'Transactions protégées via Stripe avec séquestre.',
    
    payment_title: 'PAIEMENT',
    payment_title_2: 'INTERNATIONAL',
    payment_desc: 'Payez et recevez des paiements dans votre devise locale. Support multi-devises intégré.',
    
    cta_title_1: 'PRÊT À EXPÉDIER VOTRE',
    cta_title_2: 'PREMIER VÉHICULE ?',
    cta_desc: 'Rejoignez des milliers de clients satisfaits et profitez de notre réseau de conducteurs certifiés.',
    cta_register: 'Créer un compte gratuit',
    cta_contact: 'Contacter l\'équipe',
    
    footer_tagline: 'La référence du convoyage digital en Europe et Afrique du Nord.',
    footer_services: 'Services',
    footer_legal: 'Légal',
    footer_contact: 'Contact',
    footer_cgu: 'Conditions Générales',
    footer_how_it_works: 'Comment ça marche',
    footer_privacy: 'Confidentialité',
    footer_copyright: '© 2026 Convoyageos. Tous droits réservés.',
    
    // Auth
    login_title: 'Connexion',
    login_subtitle: 'Accédez à votre espace personnel',
    login_email: 'Email',
    login_password: 'Mot de passe',
    login_submit: 'Se connecter',
    login_no_account: 'Pas encore de compte ?',
    login_register_link: 'Créer un compte',
    login_forgot_password: 'Mot de passe oublié ?',
    
    register_title: 'Créer un compte',
    register_subtitle: 'Rejoignez la communauté Convoyageos',
    register_full_name: 'Nom complet',
    register_email: 'Email',
    register_phone: 'Téléphone',
    register_password: 'Mot de passe',
    register_confirm_password: 'Confirmer le mot de passe',
    register_role: 'Je suis',
    register_role_client: 'Client',
    register_role_client_desc: 'Je cherche un transporteur',
    register_role_driver: 'Conducteur',
    register_role_driver_desc: 'Je propose mes services',
    register_submit: 'Créer mon compte',
    register_have_account: 'Déjà un compte ?',
    register_login_link: 'Se connecter',
    register_terms: 'En créant un compte, vous acceptez nos',
    register_terms_link: 'Conditions Générales',
    account_type_label: 'Type de compte',
    account_type_particulier: 'Particulier',
    account_type_particulier_desc: 'Usage personnel',
    account_type_pro: 'Professionnel',
    account_type_pro_desc: 'Entreprise / société',
    account_company_name: 'Raison sociale',
    account_siret: 'SIRET',
    
    // Email Verification
    verify_title: 'Vérifiez votre email',
    verify_subtitle: 'Nous avons envoyé un code à 6 chiffres à',
    verify_code_label: 'Code de vérification',
    verify_submit: 'Vérifier',
    verify_resend: 'Renvoyer le code',
    verify_resend_countdown: 'Renvoyer dans',
    verify_success: 'Email vérifié avec succès !',
    verify_error: 'Code invalide ou expiré',
    
    // Contact
    contact_title: 'CONTACTEZ-NOUS',
    contact_subtitle: 'Une question, un devis ou une demande particulière ? Notre équipe est là pour vous accompagner.',
    contact_info_title: 'Nos coordonnées',
    contact_address: 'Adresse',
    contact_phone: 'Téléphone',
    contact_email: 'Email',
    contact_hours: 'Horaires',
    contact_form_title: 'Envoyez-nous un message',
    contact_name: 'Nom complet',
    contact_subject: 'Sujet',
    contact_subject_quote: 'Demande de devis',
    contact_subject_info: 'Information générale',
    contact_subject_partnership: 'Partenariat',
    contact_subject_complaint: 'Réclamation',
    contact_subject_other: 'Autre',
    contact_message: 'Message',
    contact_submit: 'Envoyer le message',
    contact_success: 'Message envoyé avec succès !',
    contact_success_desc: 'Nous avons bien reçu votre message et nous vous répondrons dans les plus brefs délais.',
    
    // Dashboard Common
    dashboard_welcome: 'Bienvenue',
    dashboard_my_missions: 'Mes Missions',
    dashboard_available_missions: 'Missions Disponibles',
    dashboard_my_bids: 'Mes Offres',
    dashboard_documents: 'Documents',
    dashboard_bank_details: 'Coordonnées Bancaires',
    dashboard_payments: 'Paiements',
    dashboard_payment_history: 'Historique des Paiements',
    dashboard_statistics: 'Statistiques',
    dashboard_support: 'Support Technique',
    dashboard_profile: 'Profil',
    dashboard_settings: 'Paramètres',
    
    // Forgot Password
    forgot_password_title: 'Mot de passe oublié',
    forgot_password_desc: 'Entrez votre email pour recevoir un code de réinitialisation',
    send_reset_code: 'Envoyer le code',
    reset_code_sent: 'Code envoyé par email',
    enter_reset_code: 'Entrez le code reçu par email',
    code_sent_to: 'Code envoyé à',
    verify_code: 'Vérifier le code',
    code_verified: 'Code vérifié',
    invalid_code: 'Code invalide',
    change_email: 'Changer d\'email',
    enter_new_password: 'Créez votre nouveau mot de passe',
    new_password: 'Nouveau mot de passe',
    confirm_password: 'Confirmer le mot de passe',
    passwords_dont_match: 'Les mots de passe ne correspondent pas',
    password_too_short: 'Le mot de passe doit faire au moins 6 caractères',
    reset_password: 'Réinitialiser',
    password_reset_success: 'Mot de passe réinitialisé',
    password_reset_success_desc: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe',
    back_to_login: 'Retour à la connexion',
    verification_code: 'Code de vérification',
    
    // Mission Types & Status
    mission_type_vehicle: 'Véhicule',
    mission_type_freight: 'Marchandise',
    mission_status_open: 'Ouverte',
    mission_status_assigned: 'Assignée',
    mission_status_paid: 'Payée',
    mission_status_delivered: 'Livrée',
    mission_status_completed: 'Terminée',
    mission_status_dispute: 'Litige',
    
    // Mission Details
    mission_title: 'Titre',
    mission_description: 'Description',
    mission_origin: 'Départ',
    mission_destination: 'Arrivée',
    mission_departure_date: 'Date de départ',
    mission_departure_time: 'Heure',
    mission_distance: 'Distance',
    mission_duration: 'Durée',
    mission_price: 'Prix',
    mission_published: 'Publié le',
    mission_flexible: 'Flexible',
    mission_no_missions: 'Aucune mission',
    mission_create_new: 'Créer une mission',
    mission_view_offers: 'Voir les offres',
    mission_offers: 'offres',
    mission_offer: 'offre',
    
    // Vehicle Details
    vehicle_brand: 'Marque',
    vehicle_model: 'Modèle',
    vehicle_plate: 'Immatriculation',
    vehicle_type: 'Type de véhicule',
    vehicle_year: 'Année',
    vehicle_mileage: 'Kilométrage',
    vehicle_fuel: 'Carburant',
    
    // Bids/Offers
    bid_amount: 'Montant proposé',
    bid_message: 'Message',
    bid_submit: 'Envoyer l\'offre',
    bid_accept: 'Accepter',
    bid_reject: 'Refuser',
    bid_pending: 'En attente',
    bid_accepted: 'Acceptée',
    bid_rejected: 'Refusée',
    bid_your_offer: 'Votre offre',
    bid_driver_rating: 'Note du conducteur',
    my_evaluations: 'Mes evaluations',
    bid_verified: 'Vérifié',
    bid_insured: 'Assurance validée',
    
    // Payments
    pay_now: 'Payer maintenant',
    pay_amount: 'Montant à payer',
    payment_success: 'Paiement réussi',
    payment_failed: 'Échec du paiement',
    payment_pending: 'En attente',
    payment_date: 'Date',
    payment_method: 'Méthode',
    payment_reference: 'Référence',
    no_payment_history: 'Aucun historique de paiement',
    
    // Signatures & Contract
    sign_contract: 'Signer le contrat',
    sign_delivery: 'Signer la livraison',
    signature_client: 'Signature du client',
    signature_driver: 'Signature du conducteur',
    signature_required: 'Signature requise',
    download_contract: 'Télécharger le contrat',
    contract_ready: 'Contrat prêt',
    
    // Rating & Reviews
    rate_mission: 'Noter la mission',
    rate_driver: 'Noter le conducteur',
    rate_client: 'Noter le client',
    rating_comment: 'Votre commentaire',
    rating_submit: 'Envoyer l\'évaluation',
    rating_thank_you: 'Merci pour votre évaluation !',
    already_rated: 'Déjà noté',
    
    // Disputes
    dispute_create: 'Signaler un problème',
    dispute_reason: 'Raison du litige',
    dispute_description: 'Description',
    dispute_submit: 'Envoyer',
    dispute_open: 'Ouvert',
    dispute_resolved: 'Résolu',
    action_actions: 'Actions',
    action_pay: 'Payer',
    bid_reviews: 'avis',
    contract_sign_confirm: 'Confirmer la signature du contrat ?',
    login_btn: 'Se connecter',
    dispute_closed: 'Clôturé',
    
    // Driver Documents
    doc_license: 'Permis de conduire',
    doc_license_desc: 'Permis B valide',
    doc_id_card: 'Carte d\'identité',
    doc_id_card_desc: 'CNI ou passeport en cours de validité',
    doc_residence: 'Justificatif de domicile',
    doc_residence_desc: 'Facture ou attestation de moins de 3 mois',
    doc_insurance: 'Assurance convoyage',
    doc_insurance_desc: 'Assurance couvrant le transport',
    doc_status_missing: 'Non fourni',
    doc_status_pending: 'En attente',
    doc_status_approved: 'Validé',
    doc_status_rejected: 'Refusé',
    doc_upload: 'Téléverser',
    doc_view: 'Voir',
    doc_approve: 'Valider',
    doc_reject: 'Rejeter',
    
    // Bank Details
    bank_iban: 'IBAN',
    bank_bic: 'BIC/SWIFT',
    bank_holder: 'Titulaire du compte',
    bank_name: 'Nom de la banque',
    bank_save: 'Enregistrer',
    bank_saved: 'Coordonnées enregistrées',
    
    // Admin Dashboard
    admin_dashboard: 'Tableau de bord Admin',
    admin_drivers: 'Conducteurs',
    admin_missions: 'Missions',
    admin_disputes: 'Litiges',
    admin_payouts: 'Virements',
    admin_settings: 'Paramètres',
    admin_support: 'Support',
    admin_verify_driver: 'Valider le conducteur',
    admin_reject_driver: 'Rejeter',
    admin_close_dispute: 'Clôturer le litige',
    admin_commission_rate: 'Taux de commission',
    admin_pending_verification: 'En attente de vérification',
    admin_verified: 'Vérifiés',
    admin_all: 'Tous',
    admin_payout_process: 'Traiter le virement',
    admin_payout_processed: 'Virement traité',
    admin_view_documents: 'Voir les documents',
    
    // Messages & Chat
    chat_send: 'Envoyer',
    chat_placeholder: 'Écrivez votre message...',
    chat_no_messages: 'Aucun message',
    chat_with_driver: 'Chat avec le conducteur',
    chat_with_client: 'Chat avec le client',
    
    // Tracking
    tracking_live: 'Suivi en direct',
    tracking_driver_location: 'Position du conducteur',
    tracking_not_available: 'Suivi non disponible',
    
    // Common Actions
    action_save: 'Enregistrer',
    action_cancel: 'Annuler',
    action_confirm: 'Confirmer',
    action_delete: 'Supprimer',
    action_edit: 'Modifier',
    action_view: 'Voir',
    action_download: 'Télécharger',
    action_refresh: 'Actualiser',
    action_search: 'Rechercher',
    action_filter: 'Filtrer',
    action_close: 'Fermer',
    action_back: 'Retour',
    action_next: 'Suivant',
    action_previous: 'Précédent',
    
    // Common Labels
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    warning: 'Attention',
    info: 'Information',
    yes: 'Oui',
    no: 'Non',
    or: 'ou',
    and: 'et',
    all: 'Tous',
    none: 'Aucun',
    total: 'Total',
    date: 'Date',
    time: 'Heure',
    status: 'Statut',
    details: 'Détails',
    currency: 'Devise',
    amount: 'Montant',
    
    // Notifications
    notif_new_offer: 'Nouvelle offre reçue',
    notif_offer_accepted: 'Votre offre a été acceptée',
    notif_payment_received: 'Paiement reçu',
    notif_mission_delivered: 'Mission livrée',
    notif_mission_completed: 'Mission terminée',
    
    // Dashboard specific
    client_dashboard: 'Tableau de bord Client',
    driver_dashboard: 'Tableau de bord Conducteur',
    active_missions: 'Missions actives',
    waiting_payment: 'En attente paiement',
    ready_to_start: 'Prêt à partir',
    waiting_validation: 'En attente validation client',
    mission_completed_label: 'Mission terminée',
    new_driver: 'Nouveau conducteur',
    accept_offer: 'Accepter cette offre',
    no_offers_yet: 'Aucune offre pour le moment',
    offers_received: 'Offres reçues',
    confirm_reception: 'Confirmer réception',
    report_problem: 'Signaler un problème',
    already_rated_label: 'Noté',
    rate_driver_title: 'Noter le conducteur',
    share_experience: 'Partagez votre expérience...',
    open_dispute: 'Ouvrir le litige',
    dispute_warning: "L'ouverture d'un litige suspend le paiement au conducteur.",
    
    // Driver Dashboard
    your_proposal: 'Votre proposition',
    send_proposal: 'Envoyer ma proposition',
    verify_documents: 'Vérifiez vos documents',
    complete_documents: 'Complétez vos documents pour postuler',
    proposal_sent: 'Proposition envoyée',
    client_reviewing: 'Le client étudie votre offre',
    commission_info: 'de commission sera déduit de votre paiement final.',
    example: 'Exemple',
    you_receive: 'vous recevrez',
    search_missions: 'Opportunites',
    driver_client_rating: 'Mes évaluations',
    driver_recent_reviews: 'Avis clients recents',
    driver_no_reviews_yet: 'Pas encore d avis',
    driver_review_no_comment: 'Aucun commentaire laisse.',
    apply_to_missions: 'Postulez à des missions disponibles',
    from_you: 'de vous',
    sorted_by_proximity: 'Tri par proximité activé',
    all_distances: 'Toutes distances',
    no_missions_found: 'Aucune mission trouvée',
    expand_search: 'Essayez d\'élargir vos critères de recherche',
    come_back_later: 'Revenez plus tard',
    clear_filters: 'Effacer les filtres',
    my_position: 'Ma position',
    position_active: 'Position active',
    max_distance: 'Distance max',
    to_complete: 'À compléter',
    account_not_verified: 'Compte non vérifié',
    complete_docs_to_apply: 'Complétez vos documents pour postuler aux missions.',
    valid: 'Valide',
    pending: 'En attente',
    missing: 'Manquant',
    rejected: 'Rejeté',
    replace: 'Remplacer',
    send: 'Envoyer',
    transfers: 'Virements',
    receive_transfers: 'Pour recevoir vos virements',
    transfer_history: 'Historique des virements',
    no_transfers: 'Aucun virement',
    transfers_appear_here: 'Vos virements apparaîtront ici après chaque mission payée',
    transferred: 'Viré',
    
    // Create Mission
    plan_convoy: 'Planifier un convoyage',
    fill_details_quote: 'Remplissez les détails pour obtenir un devis instantané',
    service_type: 'Type de Service',
    service_vehicle: 'Convoyage Véhicule',
    service_merchandise: 'Transport Marchandise',
    vehicle_convoy: 'Convoyage Véhicule',
    vehicle_move_by_driver: 'Déplacement d\'un véhicule par un chauffeur.',
    merchandise_transport: 'Transport Marchandise',
    package_shipping: 'Expédition de colis ou fret.',
    vehicle_info: 'Informations du Véhicule',
    select_option: '-- Sélectionner --',
    city_car: 'Citadine',
    sedan: 'Berline',
    suv: 'SUV / 4x4',
    utility: 'Utilitaire',
    motorcycle: 'Moto',
    license_plate: 'Immatriculation',
    fiscal_hp: 'Chevaux Fiscaux',
    gasoline: 'Essence',
    diesel: 'Diesel',
    hybrid: 'Hybride',
    electric: 'Électrique',
    manual: 'Manuelle',
    automatic: 'Automatique',
    vehicle_condition: 'État du véhicule',
    vehicle_running: 'Véhicule roulant',
    vehicle_not_running: 'Véhicule non roulant (remorquage nécessaire)',
    vehicle_condition_hint: 'Un véhicule non roulant nécessitera un transport par remorque.',
    merchandise_details: 'Détails de la Marchandise',
    weight_kg: 'Poids (kg)',
    dimensions: 'Dimensions',
    
    // Documents
    update: 'Mettre à jour',
    complete_docs_to_view_missions: 'Complétez vos documents pour voir les missions',
    all_4_docs_required: 'Les 4 documents (permis, carte d\'identité, justificatif de domicile, assurance) doivent être validés.',
    trip_info: 'Informations du Trajet',
    departure_address: 'Adresse de départ',
    arrival_address: 'Adresse d\'arrivée',
    enter_address: 'Saisissez une adresse',
    distance_km: 'Distance (km)',
    duration_min: 'Durée (min)',
    recalculate_route: 'Recalculer l\'itinéraire',
    calculating: 'Calcul en cours...',
    enter_addresses_map: 'Entrez les adresses pour voir la carte',
    special_instructions: 'Message / Instructions spéciales',
    extra_info_driver: 'Informations supplémentaires pour le convoyeur...',
    get_quote_create: 'Obtenir mon devis & Créer la mission',
    route_calculated: 'Trajet calculé',
    
    // Chat
    messages: 'Messages',
    no_messages: 'Aucun message',
    start_conversation: 'Commencez la conversation',
    your_message: 'Votre message...',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    client_label: 'Client',
    driver_label: 'Conducteur',
    
    // Support Panel
    technical_support: 'Support Technique',
    we_help_you: 'Nous sommes là pour vous aider',
    new_request: 'Nouvelle demande',
    no_tickets: 'Aucun ticket',
    create_first_request: 'Créez votre première demande',
    category: 'Catégorie',
    general: 'Général',
    payment: 'Paiement',
    mission: 'Mission',
    technical: 'Technique',
    subject: 'Sujet',
    summarize_request: 'Résumez votre demande...',
    describe_problem: 'Décrivez votre problème en détail...',
    ticket_created: 'Ticket créé avec succès',
    ticket_closed: 'Ticket fermé',
    your_reply: 'Votre réponse...',
    support_label: 'Support',
    
    // GPS Tracking
    live_tracking: 'Suivi en temps réel',
    on_route: 'en route',
    tracking_unavailable: 'Suivi non disponible',
    retry: 'Réessayer',
    departure: 'Départ',
    arrival: 'Arrivée',
    
    // Admin specific
    driver_management: 'Gestion des conducteurs',
    driver_transfers: 'Virements conducteurs',
    to_transfer: 'À virer',
    done: 'Effectués',
    process_transfer: 'Traiter le virement',
    transfer_done: 'Virement marqué comme effectué',
    no_drivers: 'Aucun conducteur',
    no_transfers: 'Aucun virement',
    no_disputes: 'Aucun litige',
    select_dispute: 'Sélectionnez un litige pour voir les détails',
    dispute_details: 'Détails du litige',
    reported_on: 'Signalé le',
    reported_by: 'Signalé par',
    role: 'Rôle',
    trajectory: 'Trajet',
    mission_created_on: 'Créée le',
    resolve_dispute: 'Résoudre le litige',
    describe_resolution: 'Décrivez la résolution du litige...',
    mark_resolved: 'Marquer comme résolu',
    close_without_resolution: 'Clôturer sans résolution',
    resolution: 'Résolution',
    dispute_definitively_closed: 'Ce litige a été définitivement clôturé.',
    close_definitively: 'Clôturer définitivement',
    select_ticket: 'Sélectionnez un ticket pour voir la conversation',
    uploaded_documents: 'Documents déposés',
    not_uploaded: 'Non déposé',
    verify_all_docs: 'Vérifiez tous les documents avant de valider le conducteur',
    validate_driver: 'Valider le conducteur',
    driver_verified: 'Conducteur vérifié',
    pending_verification: 'En attente de vérification',
    uploaded_on: 'Déposé le',
    not_provided: 'Non renseigné',
  },
  
  en: {
    // Navbar
    nav_home: 'Home',
    nav_how_it_works: 'How it works',
    nav_services: 'Services',
    nav_contact: 'Contact',
    nav_login: 'Login',
    nav_register: 'Sign up',
    nav_dashboard: 'Dashboard',
    nav_logout: 'Logout',
    
    // Landing Page
    hero_badge: 'Available in France, Europe & North Africa',
    hero_title_1: 'THE NEXT-GEN',
    hero_title_2: 'VEHICLE TRANSPORT',
    hero_subtitle: 'The all-in-one SaaS platform to manage your vehicle transport and freight shipping. Simple, Secure, Instant.',
    hero_cta_quote: 'Get a free quote',
    hero_cta_driver: 'Become a Driver',
    
    stats_missions: 'Completed missions',
    stats_satisfaction: 'Satisfied customers',
    stats_insurance: 'Insurance included',
    stats_support: 'Dedicated support',
    
    // Dashboard revenue
    dashboard_revenue: 'Revenue',
    dashboard_welcome: 'Welcome',
    
    services_title: 'Our Transport Solutions',
    services_subtitle: 'Whether for a car or goods, we have the solution tailored to your needs.',
    
    service_vehicle_title: 'VEHICLE TRANSPORT',
    service_vehicle_desc: 'Moving your vehicle (car, van, motorcycle) by a certified professional driver. Ideal for remote purchases, relocations or corporate fleets.',
    service_vehicle_feature_1: 'All-risk insurance included',
    service_vehicle_feature_2: 'Digital inspection report (PDF)',
    service_vehicle_feature_3: 'Europe & Maghreb coverage',
    service_vehicle_cta: 'Simulate vehicle rate',
    
    service_freight_title: 'FREIGHT TRANSPORT',
    service_freight_desc: 'Complete logistics for your shipments to Algeria, Morocco and Tunisia. We handle transport, ferry and administrative formalities.',
    service_freight_feature_1: 'Simplified customs management',
    service_freight_feature_2: 'Guaranteed deadlines & live tracking',
    service_freight_feature_3: 'Secure door-to-door transport',
    service_freight_cta: 'Request a freight quote',
    
    feature_title_1: 'MANAGE EVERYTHING FROM',
    feature_title_2: 'YOUR CLIENT AREA',
    feature_desc: 'No more paperwork, no more endless calls. Convoyageos digitizes 100% of the process. Track your missions, pay online, sign your contracts and find your invoices in one place.',
    feature_step_1: 'Instant Quote',
    feature_step_1_desc: 'Smart pricing algorithm based on distance and vehicle.',
    feature_step_2: 'Electronic Signature',
    feature_step_2_desc: 'Automatically generated contracts signed online.',
    feature_step_3: 'Secure Payment',
    feature_step_3_desc: 'Transactions protected via Stripe with escrow.',
    
    payment_title: 'INTERNATIONAL',
    payment_title_2: 'PAYMENT',
    payment_desc: 'Pay and receive payments in your local currency. Built-in multi-currency support.',
    
    cta_title_1: 'READY TO SHIP YOUR',
    cta_title_2: 'FIRST VEHICLE?',
    cta_desc: 'Join thousands of satisfied customers and enjoy our network of certified drivers.',
    cta_register: 'Create a free account',
    cta_contact: 'Contact the team',
    
    footer_tagline: 'The reference for digital vehicle transport in Europe and North Africa.',
    footer_services: 'Services',
    footer_legal: 'Legal',
    footer_contact: 'Contact',
    footer_cgu: 'Terms of Service',
    footer_how_it_works: 'How it works',
    footer_privacy: 'Privacy',
    footer_copyright: '© 2026 Convoyageos. All rights reserved.',
    
    // Auth
    login_title: 'Login',
    login_subtitle: 'Access your personal space',
    login_email: 'Email',
    login_password: 'Password',
    login_submit: 'Sign in',
    login_no_account: 'Don\'t have an account?',
    login_register_link: 'Create an account',
    login_forgot_password: 'Forgot password?',
    
    register_title: 'Create an account',
    register_subtitle: 'Join the Convoyageos community',
    register_full_name: 'Full name',
    register_email: 'Email',
    register_phone: 'Phone',
    register_password: 'Password',
    register_confirm_password: 'Confirm password',
    register_role: 'I am',
    register_role_client: 'Client',
    register_role_client_desc: 'I\'m looking for a carrier',
    register_role_driver: 'Driver',
    register_role_driver_desc: 'I offer my services',
    register_submit: 'Create my account',
    register_have_account: 'Already have an account?',
    register_login_link: 'Sign in',
    register_terms: 'By creating an account, you accept our',
    register_terms_link: 'Terms of Service',
    account_type_label: 'Account type',
    account_type_particulier: 'Individual',
    account_type_particulier_desc: 'Personal use',
    account_type_pro: 'Professional',
    account_type_pro_desc: 'Business / company',
    account_company_name: 'Company name',
    account_siret: 'Registration number',
    
    // Email Verification
    verify_title: 'Verify your email',
    verify_subtitle: 'We sent a 6-digit code to',
    verify_code_label: 'Verification code',
    verify_submit: 'Verify',
    verify_resend: 'Resend code',
    verify_resend_countdown: 'Resend in',
    verify_success: 'Email verified successfully!',
    verify_error: 'Invalid or expired code',
    
    // Contact
    contact_title: 'CONTACT US',
    contact_subtitle: 'A question, a quote or a special request? Our team is here to help you.',
    contact_info_title: 'Our contact details',
    contact_address: 'Address',
    contact_phone: 'Phone',
    contact_email: 'Email',
    contact_hours: 'Hours',
    contact_form_title: 'Send us a message',
    contact_name: 'Full name',
    contact_subject: 'Subject',
    contact_subject_quote: 'Quote request',
    contact_subject_info: 'General information',
    contact_subject_partnership: 'Partnership',
    contact_subject_complaint: 'Complaint',
    contact_subject_other: 'Other',
    contact_message: 'Message',
    contact_submit: 'Send message',
    contact_success: 'Message sent successfully!',
    contact_success_desc: 'We have received your message and will respond as soon as possible.',
    
    // Dashboard Common
    dashboard_welcome: 'Welcome',
    dashboard_my_missions: 'My Missions',
    dashboard_available_missions: 'Available Missions',
    dashboard_my_bids: 'My Bids',
    dashboard_documents: 'Documents',
    dashboard_bank_details: 'Bank Details',
    dashboard_payments: 'Payments',
    dashboard_payment_history: 'Payment History',
    dashboard_statistics: 'Statistics',
    dashboard_support: 'Technical Support',
    dashboard_profile: 'Profile',
    dashboard_settings: 'Settings',
    
    // Mission Types & Status
    mission_type_vehicle: 'Vehicle',
    mission_type_freight: 'Freight',
    mission_status_open: 'Open',
    mission_status_assigned: 'Assigned',
    mission_status_paid: 'Paid',
    mission_status_delivered: 'Delivered',
    mission_status_completed: 'Completed',
    mission_status_dispute: 'Dispute',
    
    // Mission Details
    mission_title: 'Title',
    mission_description: 'Description',
    mission_origin: 'Origin',
    mission_destination: 'Destination',
    mission_departure_date: 'Departure date',
    mission_departure_time: 'Time',
    mission_distance: 'Distance',
    mission_duration: 'Duration',
    mission_price: 'Price',
    mission_published: 'Published on',
    mission_flexible: 'Flexible',
    mission_no_missions: 'No missions',
    mission_create_new: 'Create a mission',
    mission_view_offers: 'View offers',
    mission_offers: 'offers',
    mission_offer: 'offer',
    
    // Vehicle Details
    vehicle_brand: 'Brand',
    vehicle_model: 'Model',
    vehicle_plate: 'License plate',
    vehicle_type: 'Vehicle type',
    vehicle_year: 'Year',
    vehicle_mileage: 'Mileage',
    vehicle_fuel: 'Fuel',
    
    // Bids/Offers
    bid_amount: 'Proposed amount',
    bid_message: 'Message',
    bid_submit: 'Send offer',
    bid_accept: 'Accept',
    bid_reject: 'Reject',
    bid_pending: 'Pending',
    bid_accepted: 'Accepted',
    bid_rejected: 'Rejected',
    bid_your_offer: 'Your offer',
    bid_driver_rating: 'Driver rating',
    my_evaluations: 'My ratings',
    bid_verified: 'Verified',
    bid_insured: 'Transport insured',
    
    // Payments
    pay_now: 'Pay now',
    pay_amount: 'Amount to pay',
    payment_success: 'Payment successful',
    payment_failed: 'Payment failed',
    payment_pending: 'Pending',
    payment_date: 'Date',
    payment_method: 'Method',
    payment_reference: 'Reference',
    no_payment_history: 'No payment history',
    
    // Signatures & Contract
    sign_contract: 'Sign contract',
    sign_delivery: 'Sign delivery',
    signature_client: 'Client signature',
    signature_driver: 'Driver signature',
    signature_required: 'Signature required',
    download_contract: 'Download contract',
    contract_ready: 'Contract ready',
    
    // Rating & Reviews
    rate_mission: 'Rate mission',
    rate_driver: 'Rate driver',
    rate_client: 'Rate client',
    rating_comment: 'Your comment',
    rating_submit: 'Submit rating',
    rating_thank_you: 'Thank you for your rating!',
    already_rated: 'Already rated',
    
    // Disputes
    dispute_create: 'Report a problem',
    dispute_reason: 'Reason',
    dispute_description: 'Description',
    dispute_submit: 'Submit',
    dispute_open: 'Open',
    dispute_resolved: 'Resolved',
    action_actions: 'Actions',
    action_pay: 'Pay',
    bid_reviews: 'reviews',
    contract_sign_confirm: 'Confirm contract signature?',
    login_btn: 'Sign in',
    dispute_closed: 'Closed',
    
    // Driver Documents
    doc_license: 'Driver\'s license',
    doc_license_desc: 'Valid class B license',
    doc_id_card: 'ID card',
    doc_id_card_desc: 'Valid ID or passport',
    doc_residence: 'Proof of address',
    doc_residence_desc: 'Bill or certificate less than 3 months old',
    doc_insurance: 'Transport insurance',
    doc_insurance_desc: 'Insurance covering transport',
    doc_status_missing: 'Not provided',
    doc_status_pending: 'Pending',
    doc_status_approved: 'Approved',
    doc_status_rejected: 'Rejected',
    doc_upload: 'Upload',
    doc_view: 'View',
    doc_approve: 'Approve',
    doc_reject: 'Reject',
    
    // Bank Details
    bank_iban: 'IBAN',
    bank_bic: 'BIC/SWIFT',
    bank_holder: 'Account holder',
    bank_name: 'Bank name',
    bank_save: 'Save',
    bank_saved: 'Details saved',
    
    // Admin Dashboard
    admin_dashboard: 'Admin Dashboard',
    admin_drivers: 'Drivers',
    admin_missions: 'Missions',
    admin_disputes: 'Disputes',
    admin_payouts: 'Payouts',
    admin_settings: 'Settings',
    admin_support: 'Support',
    admin_verify_driver: 'Verify driver',
    admin_reject_driver: 'Reject',
    admin_close_dispute: 'Close dispute',
    admin_commission_rate: 'Commission rate',
    admin_pending_verification: 'Pending verification',
    admin_verified: 'Verified',
    admin_all: 'All',
    admin_payout_process: 'Process payout',
    admin_payout_processed: 'Payout processed',
    admin_view_documents: 'View documents',
    
    // Messages & Chat
    chat_send: 'Send',
    chat_placeholder: 'Write your message...',
    chat_no_messages: 'No messages',
    chat_with_driver: 'Chat with driver',
    chat_with_client: 'Chat with client',
    
    // Tracking
    tracking_live: 'Live tracking',
    tracking_driver_location: 'Driver location',
    tracking_not_available: 'Tracking not available',
    
    // Common Actions
    action_save: 'Save',
    action_cancel: 'Cancel',
    action_confirm: 'Confirm',
    action_delete: 'Delete',
    action_edit: 'Edit',
    action_view: 'View',
    action_download: 'Download',
    action_refresh: 'Refresh',
    action_search: 'Search',
    action_filter: 'Filter',
    action_close: 'Close',
    action_back: 'Back',
    action_next: 'Next',
    action_previous: 'Previous',
    
    // Common Labels
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Information',
    yes: 'Yes',
    no: 'No',
    or: 'or',
    and: 'and',
    all: 'All',
    none: 'None',
    total: 'Total',
    date: 'Date',
    time: 'Time',
    status: 'Status',
    details: 'Details',
    currency: 'Currency',
    amount: 'Amount',
    
    // Notifications
    notif_new_offer: 'New offer received',
    notif_offer_accepted: 'Your offer has been accepted',
    notif_payment_received: 'Payment received',
    notif_mission_delivered: 'Mission delivered',
    notif_mission_completed: 'Mission completed',
    
    // Dashboard specific
    client_dashboard: 'Client Dashboard',
    driver_dashboard: 'Driver Dashboard',
    active_missions: 'Active missions',
    waiting_payment: 'Waiting for payment',
    ready_to_start: 'Ready to start',
    waiting_validation: 'Waiting for client validation',
    mission_completed_label: 'Mission completed',
    new_driver: 'New driver',
    accept_offer: 'Accept this offer',
    no_offers_yet: 'No offers yet',
    offers_received: 'Offers received',
    confirm_reception: 'Confirm reception',
    report_problem: 'Report a problem',
    already_rated_label: 'Rated',
    rate_driver_title: 'Rate driver',
    share_experience: 'Share your experience...',
    open_dispute: 'Open dispute',
    dispute_warning: 'Opening a dispute suspends payment to the driver.',
    
    // Driver Dashboard
    your_proposal: 'Your proposal',
    send_proposal: 'Send my proposal',
    verify_documents: 'Verify your documents',
    complete_documents: 'Complete your documents to apply',
    proposal_sent: 'Proposal sent',
    client_reviewing: 'The client is reviewing your offer',
    commission_info: 'commission will be deducted from your final payment.',
    example: 'Example',
    you_receive: 'you will receive',
    search_missions: 'Search missions',
    driver_client_rating: 'Client rating',
    driver_recent_reviews: 'Recent client reviews',
    driver_no_reviews_yet: 'No reviews yet',
    driver_review_no_comment: 'No comment left.',
    apply_to_missions: 'Apply to available missions',
    from_you: 'from you',
    sorted_by_proximity: 'Sorted by proximity',
    all_distances: 'All distances',
    no_missions_found: 'No missions found',
    expand_search: 'Try expanding your search criteria',
    come_back_later: 'Come back later',
    clear_filters: 'Clear filters',
    my_position: 'My position',
    position_active: 'Position active',
    max_distance: 'Max distance',
    to_complete: 'To complete',
    account_not_verified: 'Account not verified',
    complete_docs_to_apply: 'Complete your documents to apply for missions.',
    valid: 'Valid',
    pending: 'Pending',
    missing: 'Missing',
    rejected: 'Rejected',
    replace: 'Replace',
    send: 'Send',
    transfers: 'Transfers',
    receive_transfers: 'To receive your transfers',
    transfer_history: 'Transfer history',
    no_transfers: 'No transfers',
    transfers_appear_here: 'Your transfers will appear here after each paid mission',
    transferred: 'Transferred',
    
    // Create Mission
    plan_convoy: 'Plan a convoy',
    fill_details_quote: 'Fill in the details to get an instant quote',
    service_type: 'Service Type',
    service_vehicle: 'Vehicle Convoy',
    service_merchandise: 'Freight Transport',
    vehicle_convoy: 'Vehicle Convoy',
    vehicle_move_by_driver: 'Vehicle transport by a driver.',
    merchandise_transport: 'Merchandise Transport',
    package_shipping: 'Package or freight shipping.',
    
    // Documents
    update: 'Update',
    complete_docs_to_view_missions: 'Complete your documents to view missions',
    all_4_docs_required: 'All 4 documents (license, ID card, proof of residence, insurance) must be validated.',
    vehicle_info: 'Vehicle Information',
    select_option: '-- Select --',
    city_car: 'City car',
    sedan: 'Sedan',
    suv: 'SUV / 4x4',
    utility: 'Utility',
    motorcycle: 'Motorcycle',
    license_plate: 'License plate',
    fiscal_hp: 'Fiscal HP',
    gasoline: 'Gasoline',
    diesel: 'Diesel',
    hybrid: 'Hybrid',
    electric: 'Electric',
    manual: 'Manual',
    automatic: 'Automatic',
    vehicle_condition: 'Vehicle condition',
    vehicle_running: 'Running vehicle',
    vehicle_not_running: 'Non-running vehicle (towing required)',
    vehicle_condition_hint: 'A non-running vehicle will require trailer transport.',
    merchandise_details: 'Merchandise Details',
    weight_kg: 'Weight (kg)',
    dimensions: 'Dimensions',
    trip_info: 'Trip Information',
    departure_address: 'Departure address',
    arrival_address: 'Arrival address',
    enter_address: 'Enter an address',
    distance_km: 'Distance (km)',
    duration_min: 'Duration (min)',
    recalculate_route: 'Recalculate route',
    calculating: 'Calculating...',
    enter_addresses_map: 'Enter addresses to see the map',
    special_instructions: 'Message / Special instructions',
    extra_info_driver: 'Additional information for the driver...',
    get_quote_create: 'Get my quote & Create mission',
    route_calculated: 'Route calculated',
    
    // Chat
    messages: 'Messages',
    no_messages: 'No messages',
    start_conversation: 'Start the conversation',
    your_message: 'Your message...',
    today: 'Today',
    yesterday: 'Yesterday',
    client_label: 'Client',
    driver_label: 'Driver',
    
    // Support Panel
    technical_support: 'Technical Support',
    we_help_you: 'We are here to help you',
    new_request: 'New request',
    no_tickets: 'No tickets',
    create_first_request: 'Create your first request',
    category: 'Category',
    general: 'General',
    payment: 'Payment',
    mission: 'Mission',
    technical: 'Technical',
    subject: 'Subject',
    summarize_request: 'Summarize your request...',
    describe_problem: 'Describe your problem in detail...',
    ticket_created: 'Ticket created successfully',
    ticket_closed: 'Ticket closed',
    your_reply: 'Your reply...',
    support_label: 'Support',
    
    // GPS Tracking
    live_tracking: 'Live tracking',
    on_route: 'on route',
    tracking_unavailable: 'Tracking unavailable',
    retry: 'Retry',
    departure: 'Departure',
    arrival: 'Arrival',
    
    // Admin specific
    driver_management: 'Driver management',
    driver_transfers: 'Driver transfers',
    to_transfer: 'To transfer',
    done: 'Done',
    process_transfer: 'Process transfer',
    transfer_done: 'Transfer marked as done',
    no_drivers: 'No drivers',
    no_disputes: 'No disputes',
    select_dispute: 'Select a dispute to see details',
    dispute_details: 'Dispute details',
    reported_on: 'Reported on',
    reported_by: 'Reported by',
    role: 'Role',
    trajectory: 'Trajectory',
    mission_created_on: 'Created on',
    resolve_dispute: 'Resolve dispute',
    describe_resolution: 'Describe the resolution...',
    mark_resolved: 'Mark as resolved',
    close_without_resolution: 'Close without resolution',
    resolution: 'Resolution',
    dispute_definitively_closed: 'This dispute has been definitively closed.',
    close_definitively: 'Close definitively',
    select_ticket: 'Select a ticket to see the conversation',
    uploaded_documents: 'Uploaded documents',
    not_uploaded: 'Not uploaded',
    verify_all_docs: 'Verify all documents before validating the driver',
    validate_driver: 'Validate driver',
    driver_verified: 'Driver verified',
    pending_verification: 'Pending verification',
    uploaded_on: 'Uploaded on',
    not_provided: 'Not provided',
  },
  
  ar: {
    // Navbar
    nav_home: 'الرئيسية',
    nav_how_it_works: 'كيف يعمل',
    nav_services: 'الخدمات',
    nav_contact: 'اتصل بنا',
    nav_login: 'تسجيل الدخول',
    nav_register: 'إنشاء حساب',
    nav_dashboard: 'لوحة التحكم',
    nav_logout: 'تسجيل الخروج',
    
    // Landing Page
    hero_badge: 'متوفر في فرنسا وأوروبا وشمال إفريقيا',
    hero_title_1: 'نقل المركبات',
    hero_title_2: 'من الجيل الجديد',
    hero_subtitle: 'منصة SaaS شاملة لإدارة نقل المركبات والشحن. بسيط، آمن، فوري.',
    hero_cta_quote: 'احصل على عرض سعر مجاني',
    hero_cta_driver: 'كن سائقاً',
    
    stats_missions: 'مهمة منجزة',
    stats_satisfaction: 'عملاء راضون',
    stats_insurance: 'تأمين مشمول',
    stats_support: 'دعم مخصص',
    
    // Dashboard revenue
    dashboard_revenue: 'الإيرادات',
    dashboard_welcome: 'مرحباً',
    
    services_title: 'حلول النقل لدينا',
    services_subtitle: 'سواء كانت سيارة أو بضائع، لدينا الحل المناسب لاحتياجاتك.',
    
    service_vehicle_title: 'نقل المركبات',
    service_vehicle_desc: 'نقل مركبتك بواسطة سائق محترف معتمد.',
    service_vehicle_feature_1: 'تأمين شامل مشمول',
    service_vehicle_feature_2: 'تقرير فحص رقمي (PDF)',
    service_vehicle_feature_3: 'تغطية أوروبا والمغرب العربي',
    service_vehicle_cta: 'محاكاة سعر المركبة',
    
    service_freight_title: 'نقل البضائع',
    service_freight_desc: 'خدمات لوجستية كاملة لشحناتك إلى الجزائر والمغرب وتونس.',
    service_freight_feature_1: 'إدارة جمارك مبسطة',
    service_freight_feature_2: 'مواعيد مضمونة وتتبع مباشر',
    service_freight_feature_3: 'نقل آمن من الباب للباب',
    service_freight_cta: 'طلب عرض سعر للشحن',
    
    feature_title_1: 'أدر كل شيء من',
    feature_title_2: 'مساحتك الخاصة',
    feature_desc: 'لا مزيد من الأوراق، لا مزيد من المكالمات. رقمنة 100٪ من العملية.',
    feature_step_1: 'عرض سعر فوري',
    feature_step_1_desc: 'خوارزمية تسعير ذكية.',
    feature_step_2: 'توقيع إلكتروني',
    feature_step_2_desc: 'عقود يتم إنشاؤها وتوقيعها عبر الإنترنت.',
    feature_step_3: 'دفع آمن',
    feature_step_3_desc: 'معاملات محمية عبر Stripe.',
    
    payment_title: 'الدفع',
    payment_title_2: 'الدولي',
    payment_desc: 'ادفع واستلم المدفوعات بعملتك المحلية.',
    
    cta_title_1: 'مستعد لشحن',
    cta_title_2: 'مركبتك الأولى؟',
    cta_desc: 'انضم إلى آلاف العملاء الراضين.',
    cta_register: 'إنشاء حساب مجاني',
    cta_contact: 'اتصل بالفريق',
    
    footer_tagline: 'المرجع في نقل المركبات الرقمي.',
    footer_services: 'الخدمات',
    footer_legal: 'قانوني',
    footer_contact: 'اتصل',
    footer_cgu: 'شروط الخدمة',
    footer_how_it_works: 'كيف يعمل',
    footer_privacy: 'الخصوصية',
    footer_copyright: '© 2026 Convoyageos. جميع الحقوق محفوظة.',
    
    // Auth
    login_title: 'تسجيل الدخول',
    login_subtitle: 'ادخل إلى مساحتك الشخصية',
    login_email: 'البريد الإلكتروني',
    login_password: 'كلمة المرور',
    login_submit: 'دخول',
    login_no_account: 'ليس لديك حساب؟',
    login_register_link: 'إنشاء حساب',
    login_forgot_password: 'نسيت كلمة المرور؟',
    
    register_title: 'إنشاء حساب',
    register_subtitle: 'انضم إلى مجتمع Convoyageos',
    register_full_name: 'الاسم الكامل',
    register_email: 'البريد الإلكتروني',
    register_phone: 'الهاتف',
    register_password: 'كلمة المرور',
    register_confirm_password: 'تأكيد كلمة المرور',
    register_role: 'أنا',
    register_role_client: 'عميل',
    register_role_client_desc: 'أبحث عن ناقل',
    register_role_driver: 'سائق',
    register_role_driver_desc: 'أقدم خدماتي',
    register_submit: 'إنشاء حسابي',
    register_have_account: 'لديك حساب؟',
    register_login_link: 'تسجيل الدخول',
    register_terms: 'بإنشاء حساب، أنت توافق على',
    register_terms_link: 'شروط الخدمة',
    
    // Email Verification
    verify_title: 'تحقق من بريدك الإلكتروني',
    verify_subtitle: 'أرسلنا رمزًا مكونًا من 6 أرقام إلى',
    verify_code_label: 'رمز التحقق',
    verify_submit: 'تحقق',
    verify_resend: 'إعادة إرسال الرمز',
    verify_resend_countdown: 'إعادة الإرسال في',
    verify_success: 'تم التحقق من البريد الإلكتروني بنجاح!',
    verify_error: 'رمز غير صالح أو منتهي الصلاحية',
    
    // Contact
    contact_title: 'اتصل بنا',
    contact_subtitle: 'سؤال أو عرض سعر أو طلب خاص؟ فريقنا هنا لمساعدتك.',
    contact_info_title: 'معلومات الاتصال',
    contact_address: 'العنوان',
    contact_phone: 'الهاتف',
    contact_email: 'البريد الإلكتروني',
    contact_hours: 'ساعات العمل',
    contact_form_title: 'أرسل لنا رسالة',
    contact_name: 'الاسم الكامل',
    contact_subject: 'الموضوع',
    contact_subject_quote: 'طلب عرض سعر',
    contact_subject_info: 'معلومات عامة',
    contact_subject_partnership: 'شراكة',
    contact_subject_complaint: 'شكوى',
    contact_subject_other: 'أخرى',
    contact_message: 'الرسالة',
    contact_submit: 'إرسال الرسالة',
    contact_success: 'تم إرسال الرسالة بنجاح!',
    contact_success_desc: 'لقد تلقينا رسالتك وسنرد في أقرب وقت ممكن.',
    
    // Dashboard Common
    dashboard_welcome: 'مرحباً',
    dashboard_my_missions: 'مهامي',
    dashboard_available_missions: 'المهام المتاحة',
    dashboard_my_bids: 'عروضي',
    dashboard_documents: 'المستندات',
    dashboard_bank_details: 'التفاصيل المصرفية',
    dashboard_payments: 'المدفوعات',
    dashboard_payment_history: 'سجل المدفوعات',
    dashboard_statistics: 'الإحصائيات',
    dashboard_support: 'الدعم الفني',
    dashboard_profile: 'الملف الشخصي',
    dashboard_settings: 'الإعدادات',
    
    // Mission Types & Status
    mission_type_vehicle: 'مركبة',
    mission_type_freight: 'بضائع',
    mission_status_open: 'مفتوحة',
    mission_status_assigned: 'معينة',
    mission_status_paid: 'مدفوعة',
    mission_status_delivered: 'مسلمة',
    mission_status_completed: 'مكتملة',
    mission_status_dispute: 'نزاع',
    
    // Mission Details
    mission_title: 'العنوان',
    mission_description: 'الوصف',
    mission_origin: 'نقطة الانطلاق',
    mission_destination: 'الوجهة',
    mission_departure_date: 'تاريخ المغادرة',
    mission_departure_time: 'الوقت',
    mission_distance: 'المسافة',
    mission_duration: 'المدة',
    mission_price: 'السعر',
    mission_published: 'نشرت في',
    mission_flexible: 'مرن',
    mission_no_missions: 'لا توجد مهام',
    mission_create_new: 'إنشاء مهمة',
    mission_view_offers: 'عرض العروض',
    mission_offers: 'عروض',
    mission_offer: 'عرض',
    
    // Vehicle Details
    vehicle_brand: 'الماركة',
    vehicle_model: 'الموديل',
    vehicle_plate: 'رقم اللوحة',
    vehicle_type: 'نوع المركبة',
    vehicle_year: 'السنة',
    vehicle_mileage: 'عداد الكيلومترات',
    vehicle_fuel: 'الوقود',
    
    // Bids/Offers
    bid_amount: 'المبلغ المقترح',
    bid_message: 'الرسالة',
    bid_submit: 'إرسال العرض',
    bid_accept: 'قبول',
    bid_reject: 'رفض',
    bid_pending: 'قيد الانتظار',
    bid_accepted: 'مقبول',
    bid_rejected: 'مرفوض',
    bid_your_offer: 'عرضك',
    bid_driver_rating: 'تقييم السائق',
    my_evaluations: 'تقييماتي',
    bid_verified: 'موثق',
    bid_insured: 'مؤمن للنقل',
    
    // Payments
    pay_now: 'ادفع الآن',
    pay_amount: 'المبلغ المستحق',
    payment_success: 'تم الدفع بنجاح',
    payment_failed: 'فشل الدفع',
    payment_pending: 'قيد الانتظار',
    payment_date: 'التاريخ',
    payment_method: 'طريقة الدفع',
    payment_reference: 'المرجع',
    no_payment_history: 'لا يوجد سجل مدفوعات',
    
    // Signatures & Contract
    sign_contract: 'توقيع العقد',
    sign_delivery: 'توقيع التسليم',
    signature_client: 'توقيع العميل',
    signature_driver: 'توقيع السائق',
    signature_required: 'التوقيع مطلوب',
    download_contract: 'تحميل العقد',
    contract_ready: 'العقد جاهز',
    
    // Rating & Reviews
    rate_mission: 'تقييم المهمة',
    rate_driver: 'تقييم السائق',
    rate_client: 'تقييم العميل',
    rating_comment: 'تعليقك',
    rating_submit: 'إرسال التقييم',
    rating_thank_you: 'شكراً لتقييمك!',
    already_rated: 'تم التقييم',
    
    // Disputes
    dispute_create: 'الإبلاغ عن مشكلة',
    dispute_reason: 'السبب',
    dispute_description: 'الوصف',
    dispute_submit: 'إرسال',
    dispute_open: 'مفتوح',
    dispute_resolved: 'تم الحل',
    action_actions: 'إجراءات',
    action_pay: 'دفع',
    bid_reviews: 'تقييمات',
    contract_sign_confirm: 'تأكيد توقيع العقد؟',
    login_btn: 'تسجيل الدخول',
    dispute_closed: 'مغلق',
    
    // Driver Documents
    doc_license: 'رخصة القيادة',
    doc_license_desc: 'رخصة فئة ب صالحة',
    doc_id_card: 'بطاقة الهوية',
    doc_id_card_desc: 'هوية أو جواز سفر صالح',
    doc_residence: 'إثبات العنوان',
    doc_residence_desc: 'فاتورة أو شهادة أقل من 3 أشهر',
    doc_insurance: 'تأمين النقل',
    doc_insurance_desc: 'تأمين يغطي النقل',
    doc_status_missing: 'غير مقدم',
    doc_status_pending: 'قيد الانتظار',
    doc_status_approved: 'معتمد',
    doc_status_rejected: 'مرفوض',
    doc_upload: 'رفع',
    doc_view: 'عرض',
    doc_approve: 'اعتماد',
    doc_reject: 'رفض',
    
    // Bank Details
    bank_iban: 'آيبان',
    bank_bic: 'سويفت',
    bank_holder: 'صاحب الحساب',
    bank_name: 'اسم البنك',
    bank_save: 'حفظ',
    bank_saved: 'تم حفظ البيانات',
    
    // Admin Dashboard
    admin_dashboard: 'لوحة تحكم المشرف',
    admin_drivers: 'السائقون',
    admin_missions: 'المهام',
    admin_disputes: 'النزاعات',
    admin_payouts: 'التحويلات',
    admin_settings: 'الإعدادات',
    admin_support: 'الدعم',
    admin_verify_driver: 'التحقق من السائق',
    admin_reject_driver: 'رفض',
    admin_close_dispute: 'إغلاق النزاع',
    admin_commission_rate: 'معدل العمولة',
    admin_pending_verification: 'قيد التحقق',
    admin_verified: 'موثقون',
    admin_all: 'الكل',
    admin_payout_process: 'معالجة التحويل',
    admin_payout_processed: 'تم التحويل',
    admin_view_documents: 'عرض المستندات',
    
    // Messages & Chat
    chat_send: 'إرسال',
    chat_placeholder: 'اكتب رسالتك...',
    chat_no_messages: 'لا توجد رسائل',
    chat_with_driver: 'محادثة مع السائق',
    chat_with_client: 'محادثة مع العميل',
    
    // Tracking
    tracking_live: 'تتبع مباشر',
    tracking_driver_location: 'موقع السائق',
    tracking_not_available: 'التتبع غير متاح',
    
    // Common Actions
    action_save: 'حفظ',
    action_cancel: 'إلغاء',
    action_confirm: 'تأكيد',
    action_delete: 'حذف',
    action_edit: 'تعديل',
    action_view: 'عرض',
    action_download: 'تحميل',
    action_refresh: 'تحديث',
    action_search: 'بحث',
    action_filter: 'تصفية',
    action_close: 'إغلاق',
    action_back: 'رجوع',
    action_next: 'التالي',
    action_previous: 'السابق',
    
    // Common Labels
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    warning: 'تحذير',
    info: 'معلومات',
    yes: 'نعم',
    no: 'لا',
    or: 'أو',
    and: 'و',
    all: 'الكل',
    none: 'لا شيء',
    total: 'المجموع',
    date: 'التاريخ',
    time: 'الوقت',
    status: 'الحالة',
    details: 'التفاصيل',
    currency: 'العملة',
    amount: 'المبلغ',
    
    // Notifications
    notif_new_offer: 'عرض جديد',
    notif_offer_accepted: 'تم قبول عرضك',
    notif_payment_received: 'تم استلام الدفعة',
    notif_mission_delivered: 'تم تسليم المهمة',
    notif_mission_completed: 'اكتملت المهمة',
    
    // Dashboard specific
    client_dashboard: 'لوحة تحكم العميل',
    driver_dashboard: 'لوحة تحكم السائق',
    active_missions: 'المهام النشطة',
    waiting_payment: 'في انتظار الدفع',
    ready_to_start: 'جاهز للانطلاق',
    waiting_validation: 'في انتظار تأكيد العميل',
    mission_completed_label: 'المهمة مكتملة',
    new_driver: 'سائق جديد',
    accept_offer: 'قبول هذا العرض',
    no_offers_yet: 'لا توجد عروض حتى الآن',
    offers_received: 'العروض المستلمة',
    confirm_reception: 'تأكيد الاستلام',
    report_problem: 'الإبلاغ عن مشكلة',
    already_rated_label: 'تم التقييم',
    rate_driver_title: 'تقييم السائق',
    share_experience: 'شارك تجربتك...',
    open_dispute: 'فتح نزاع',
    dispute_warning: 'فتح نزاع يعلق الدفع للسائق.',
    your_proposal: 'عرضك',
    send_proposal: 'إرسال عرضي',
    verify_documents: 'تحقق من مستنداتك',
    complete_documents: 'أكمل مستنداتك للتقديم',
    proposal_sent: 'تم إرسال العرض',
    client_reviewing: 'العميل يدرس عرضك',
    commission_info: 'عمولة ستخصم من دفعتك النهائية.',
    example: 'مثال',
    you_receive: 'ستستلم',
    search_missions: 'البحث عن مهام',
    driver_client_rating: 'تقييم العملاء',
    driver_recent_reviews: 'آراء العملاء الأخيرة',
    driver_no_reviews_yet: 'لا توجد تقييمات بعد',
    driver_review_no_comment: 'لم يتم ترك تعليق.',
    apply_to_missions: 'تقدم للمهام المتاحة',
    from_you: 'منك',
    sorted_by_proximity: 'مرتب حسب القرب',
    all_distances: 'جميع المسافات',
    no_missions_found: 'لم يتم العثور على مهام',
    expand_search: 'حاول توسيع معايير البحث',
    come_back_later: 'عد لاحقاً',
    clear_filters: 'مسح الفلاتر',
    my_position: 'موقعي',
    position_active: 'الموقع نشط',
    max_distance: 'أقصى مسافة',
    to_complete: 'للإكمال',
    account_not_verified: 'الحساب غير موثق',
    complete_docs_to_apply: 'أكمل مستنداتك للتقديم على المهام.',
    valid: 'صالح',
    pending: 'قيد الانتظار',
    missing: 'مفقود',
    rejected: 'مرفوض',
    replace: 'استبدال',
    send: 'إرسال',
    transfers: 'التحويلات',
    receive_transfers: 'لاستلام تحويلاتك',
    transfer_history: 'سجل التحويلات',
    no_transfers: 'لا توجد تحويلات',
    transfers_appear_here: 'ستظهر تحويلاتك هنا بعد كل مهمة مدفوعة',
    transferred: 'تم التحويل',
    plan_convoy: 'التخطيط لنقل',
    fill_details_quote: 'املأ التفاصيل للحصول على عرض سعر فوري',
    service_type: 'نوع الخدمة',
    service_vehicle: 'نقل المركبات',
    service_merchandise: 'نقل البضائع',
    vehicle_convoy: 'نقل المركبات',
    vehicle_move_by_driver: 'نقل المركبة بواسطة سائق.',
    merchandise_transport: 'نقل البضائع',
    package_shipping: 'شحن الطرود أو البضائع.',
    
    // Documents
    update: 'تحديث',
    complete_docs_to_view_missions: 'أكمل مستنداتك لعرض المهام',
    all_4_docs_required: 'يجب التحقق من المستندات الأربعة (الرخصة، بطاقة الهوية، إثبات الإقامة، التأمين).',
    vehicle_info: 'معلومات المركبة',
    select_option: '-- اختر --',
    city_car: 'سيارة مدينة',
    sedan: 'سيدان',
    suv: 'SUV / 4x4',
    utility: 'نفعية',
    motorcycle: 'دراجة نارية',
    license_plate: 'رقم اللوحة',
    fiscal_hp: 'الحصان الضريبي',
    gasoline: 'بنزين',
    diesel: 'ديزل',
    hybrid: 'هجين',
    electric: 'كهربائي',
    manual: 'يدوي',
    automatic: 'أوتوماتيك',
    vehicle_condition: 'حالة المركبة',
    vehicle_running: 'مركبة تعمل',
    vehicle_not_running: 'مركبة لا تعمل (تحتاج سحب)',
    vehicle_condition_hint: 'المركبة غير العاملة تحتاج إلى نقل بمقطورة.',
    merchandise_details: 'تفاصيل البضائع',
    weight_kg: 'الوزن (كغ)',
    dimensions: 'الأبعاد',
    trip_info: 'معلومات الرحلة',
    departure_address: 'عنوان المغادرة',
    arrival_address: 'عنوان الوصول',
    enter_address: 'أدخل عنوان',
    distance_km: 'المسافة (كم)',
    duration_min: 'المدة (دقيقة)',
    recalculate_route: 'إعادة حساب المسار',
    calculating: 'جاري الحساب...',
    enter_addresses_map: 'أدخل العناوين لعرض الخريطة',
    special_instructions: 'رسالة / تعليمات خاصة',
    extra_info_driver: 'معلومات إضافية للسائق...',
    get_quote_create: 'احصل على عرض السعر وأنشئ المهمة',
    route_calculated: 'تم حساب المسار',
    messages: 'الرسائل',
    no_messages: 'لا توجد رسائل',
    start_conversation: 'ابدأ المحادثة',
    your_message: 'رسالتك...',
    today: 'اليوم',
    yesterday: 'أمس',
    client_label: 'عميل',
    driver_label: 'سائق',
    technical_support: 'الدعم الفني',
    we_help_you: 'نحن هنا لمساعدتك',
    new_request: 'طلب جديد',
    no_tickets: 'لا توجد تذاكر',
    create_first_request: 'أنشئ طلبك الأول',
    category: 'الفئة',
    general: 'عام',
    payment: 'الدفع',
    mission: 'المهمة',
    technical: 'تقني',
    subject: 'الموضوع',
    summarize_request: 'لخص طلبك...',
    describe_problem: 'صف مشكلتك بالتفصيل...',
    ticket_created: 'تم إنشاء التذكرة بنجاح',
    ticket_closed: 'التذكرة مغلقة',
    your_reply: 'ردك...',
    support_label: 'الدعم',
    live_tracking: 'التتبع المباشر',
    on_route: 'في الطريق',
    tracking_unavailable: 'التتبع غير متاح',
    retry: 'إعادة المحاولة',
    departure: 'المغادرة',
    arrival: 'الوصول',
    driver_management: 'إدارة السائقين',
    driver_transfers: 'تحويلات السائقين',
    to_transfer: 'للتحويل',
    done: 'تم',
    process_transfer: 'معالجة التحويل',
    transfer_done: 'تم وضع علامة على التحويل كمكتمل',
    no_drivers: 'لا يوجد سائقين',
    no_disputes: 'لا توجد نزاعات',
    select_dispute: 'اختر نزاعًا لعرض التفاصيل',
    dispute_details: 'تفاصيل النزاع',
    reported_on: 'تم الإبلاغ في',
    reported_by: 'تم الإبلاغ بواسطة',
    role: 'الدور',
    trajectory: 'المسار',
    mission_created_on: 'أنشئت في',
    resolve_dispute: 'حل النزاع',
    describe_resolution: 'صف الحل...',
    mark_resolved: 'وضع علامة كمحلول',
    close_without_resolution: 'إغلاق بدون حل',
    resolution: 'الحل',
    dispute_definitively_closed: 'تم إغلاق هذا النزاع نهائياً.',
    close_definitively: 'إغلاق نهائي',
    select_ticket: 'اختر تذكرة لعرض المحادثة',
    uploaded_documents: 'المستندات المرفوعة',
    not_uploaded: 'غير مرفوع',
    verify_all_docs: 'تحقق من جميع المستندات قبل التحقق من السائق',
    validate_driver: 'التحقق من السائق',
    driver_verified: 'السائق موثق',
    pending_verification: 'قيد التحقق',
    uploaded_on: 'تم الرفع في',
    not_provided: 'غير مقدم',
  },
  
  es: {
    // Navbar
    nav_home: 'Inicio',
    nav_how_it_works: 'Cómo funciona',
    nav_services: 'Servicios',
    nav_contact: 'Contacto',
    nav_login: 'Iniciar sesión',
    nav_register: 'Registrarse',
    nav_dashboard: 'Mi Panel',
    nav_logout: 'Cerrar sesión',
    
    // Landing Page
    hero_badge: 'Disponible en Francia, Europa y Norte de África',
    hero_title_1: 'EL TRANSPORTE',
    hero_title_2: 'DE NUEVA GENERACIÓN',
    hero_subtitle: 'La plataforma SaaS todo en uno para gestionar sus transportes de vehículos y mercancías. Simple, Seguro, Instantáneo.',
    hero_cta_quote: 'Obtener presupuesto gratis',
    hero_cta_driver: 'Ser Conductor',
    
    stats_missions: 'Misiones completadas',
    stats_satisfaction: 'Clientes satisfechos',
    stats_insurance: 'Seguro incluido',
    stats_support: 'Soporte dedicado',
    
    // Dashboard revenue
    dashboard_revenue: 'Ingresos',
    dashboard_welcome: 'Bienvenido',
    
    services_title: 'Nuestras Soluciones de Transporte',
    services_subtitle: 'Ya sea para un coche o mercancías, tenemos la solución adaptada a sus necesidades.',
    
    service_vehicle_title: 'TRANSPORTE DE VEHÍCULOS',
    service_vehicle_desc: 'Traslado de su vehículo por un conductor profesional certificado.',
    service_vehicle_feature_1: 'Seguro a todo riesgo incluido',
    service_vehicle_feature_2: 'Informe de inspección digital (PDF)',
    service_vehicle_feature_3: 'Cobertura Europa y Magreb',
    service_vehicle_cta: 'Simular tarifa vehículo',
    
    service_freight_title: 'TRANSPORTE DE MERCANCÍAS',
    service_freight_desc: 'Logística completa para sus envíos a Argelia, Marruecos y Túnez.',
    service_freight_feature_1: 'Gestión aduanera simplificada',
    service_freight_feature_2: 'Plazos garantizados y seguimiento en vivo',
    service_freight_feature_3: 'Transporte seguro puerta a puerta',
    service_freight_cta: 'Solicitar presupuesto de carga',
    
    feature_title_1: 'GESTIONE TODO DESDE',
    feature_title_2: 'SU ÁREA DE CLIENTE',
    feature_desc: 'Sin más papeles, sin más llamadas interminables. Convoyageos digitaliza el 100% del proceso.',
    feature_step_1: 'Presupuesto Instantáneo',
    feature_step_1_desc: 'Algoritmo de precios inteligente.',
    feature_step_2: 'Firma Electrónica',
    feature_step_2_desc: 'Contratos generados y firmados en línea.',
    feature_step_3: 'Pago Seguro',
    feature_step_3_desc: 'Transacciones protegidas vía Stripe.',
    
    payment_title: 'PAGO',
    payment_title_2: 'INTERNACIONAL',
    payment_desc: 'Pague y reciba pagos en su moneda local.',
    
    cta_title_1: '¿LISTO PARA ENVIAR SU',
    cta_title_2: 'PRIMER VEHÍCULO?',
    cta_desc: 'Únase a miles de clientes satisfechos.',
    cta_register: 'Crear cuenta gratis',
    cta_contact: 'Contactar al equipo',
    
    footer_tagline: 'La referencia del transporte digital de vehículos.',
    footer_services: 'Servicios',
    footer_legal: 'Legal',
    footer_contact: 'Contacto',
    footer_cgu: 'Términos de Servicio',
    footer_how_it_works: 'Cómo funciona',
    footer_privacy: 'Privacidad',
    footer_copyright: '© 2026 Convoyageos. Todos los derechos reservados.',
    
    // Auth
    login_title: 'Iniciar sesión',
    login_subtitle: 'Acceda a su espacio personal',
    login_email: 'Correo electrónico',
    login_password: 'Contraseña',
    login_submit: 'Entrar',
    login_no_account: '¿No tiene cuenta?',
    login_register_link: 'Crear una cuenta',
    login_forgot_password: '¿Olvidó su contraseña?',
    
    register_title: 'Crear una cuenta',
    register_subtitle: 'Únase a la comunidad Convoyageos',
    register_full_name: 'Nombre completo',
    register_email: 'Correo electrónico',
    register_phone: 'Teléfono',
    register_password: 'Contraseña',
    register_confirm_password: 'Confirmar contraseña',
    register_role: 'Soy',
    register_role_client: 'Cliente',
    register_role_client_desc: 'Busco un transportista',
    register_role_driver: 'Conductor',
    register_role_driver_desc: 'Ofrezco mis servicios',
    register_submit: 'Crear mi cuenta',
    register_have_account: '¿Ya tiene cuenta?',
    register_login_link: 'Iniciar sesión',
    register_terms: 'Al crear una cuenta, acepta nuestros',
    register_terms_link: 'Términos de Servicio',
    
    // Email Verification
    verify_title: 'Verifique su correo',
    verify_subtitle: 'Enviamos un código de 6 dígitos a',
    verify_code_label: 'Código de verificación',
    verify_submit: 'Verificar',
    verify_resend: 'Reenviar código',
    verify_resend_countdown: 'Reenviar en',
    verify_success: '¡Correo verificado con éxito!',
    verify_error: 'Código inválido o expirado',
    
    // Contact
    contact_title: 'CONTÁCTENOS',
    contact_subtitle: '¿Una pregunta, un presupuesto o una solicitud especial? Nuestro equipo está aquí para ayudarle.',
    contact_info_title: 'Nuestros datos de contacto',
    contact_address: 'Dirección',
    contact_phone: 'Teléfono',
    contact_email: 'Correo electrónico',
    contact_hours: 'Horarios',
    contact_form_title: 'Envíenos un mensaje',
    contact_name: 'Nombre completo',
    contact_subject: 'Asunto',
    contact_subject_quote: 'Solicitud de presupuesto',
    contact_subject_info: 'Información general',
    contact_subject_partnership: 'Asociación',
    contact_subject_complaint: 'Reclamación',
    contact_subject_other: 'Otro',
    contact_message: 'Mensaje',
    contact_submit: 'Enviar mensaje',
    contact_success: '¡Mensaje enviado con éxito!',
    contact_success_desc: 'Hemos recibido su mensaje y responderemos lo antes posible.',
    
    // Dashboard Common
    dashboard_welcome: 'Bienvenido',
    dashboard_my_missions: 'Mis Misiones',
    dashboard_available_missions: 'Misiones Disponibles',
    dashboard_my_bids: 'Mis Ofertas',
    dashboard_documents: 'Documentos',
    dashboard_bank_details: 'Datos Bancarios',
    dashboard_payments: 'Pagos',
    dashboard_payment_history: 'Historial de Pagos',
    dashboard_statistics: 'Estadísticas',
    dashboard_support: 'Soporte Técnico',
    dashboard_profile: 'Perfil',
    dashboard_settings: 'Configuración',
    
    // Mission Types & Status
    mission_type_vehicle: 'Vehículo',
    mission_type_freight: 'Mercancía',
    mission_status_open: 'Abierta',
    mission_status_assigned: 'Asignada',
    mission_status_paid: 'Pagada',
    mission_status_delivered: 'Entregada',
    mission_status_completed: 'Completada',
    mission_status_dispute: 'Disputa',
    
    // Mission Details
    mission_title: 'Título',
    mission_description: 'Descripción',
    mission_origin: 'Origen',
    mission_destination: 'Destino',
    mission_departure_date: 'Fecha de salida',
    mission_departure_time: 'Hora',
    mission_distance: 'Distancia',
    mission_duration: 'Duración',
    mission_price: 'Precio',
    mission_published: 'Publicado el',
    mission_flexible: 'Flexible',
    mission_no_missions: 'Sin misiones',
    mission_create_new: 'Crear una misión',
    mission_view_offers: 'Ver ofertas',
    mission_offers: 'ofertas',
    mission_offer: 'oferta',
    
    // All other keys similar pattern...
    vehicle_brand: 'Marca',
    vehicle_model: 'Modelo',
    vehicle_plate: 'Matrícula',
    vehicle_type: 'Tipo de vehículo',
    vehicle_year: 'Año',
    vehicle_mileage: 'Kilometraje',
    vehicle_fuel: 'Combustible',
    
    bid_amount: 'Monto propuesto',
    bid_message: 'Mensaje',
    bid_submit: 'Enviar oferta',
    bid_accept: 'Aceptar',
    bid_reject: 'Rechazar',
    bid_pending: 'Pendiente',
    bid_accepted: 'Aceptada',
    bid_rejected: 'Rechazada',
    bid_your_offer: 'Su oferta',
    bid_driver_rating: 'Calificación del conductor',
    my_evaluations: 'Mis calificaciones',
    bid_verified: 'Verificado',
    bid_insured: 'Asegurado',
    
    pay_now: 'Pagar ahora',
    pay_amount: 'Monto a pagar',
    payment_success: 'Pago exitoso',
    payment_failed: 'Pago fallido',
    payment_pending: 'Pendiente',
    payment_date: 'Fecha',
    payment_method: 'Método',
    payment_reference: 'Referencia',
    no_payment_history: 'Sin historial de pagos',
    
    sign_contract: 'Firmar contrato',
    sign_delivery: 'Firmar entrega',
    signature_client: 'Firma del cliente',
    signature_driver: 'Firma del conductor',
    signature_required: 'Firma requerida',
    download_contract: 'Descargar contrato',
    contract_ready: 'Contrato listo',
    
    rate_mission: 'Calificar misión',
    rate_driver: 'Calificar conductor',
    rate_client: 'Calificar cliente',
    rating_comment: 'Su comentario',
    rating_submit: 'Enviar calificación',
    rating_thank_you: '¡Gracias por su calificación!',
    already_rated: 'Ya calificado',
    
    dispute_create: 'Reportar un problema',
    dispute_reason: 'Razón',
    dispute_description: 'Descripción',
    dispute_submit: 'Enviar',
    dispute_open: 'Abierto',
    dispute_resolved: 'Resuelto',
    action_actions: 'Acciones',
    action_pay: 'Pagar',
    bid_reviews: 'reseñas',
    contract_sign_confirm: '¿Confirmar la firma del contrato?',
    login_btn: 'Iniciar sesión',
    dispute_closed: 'Cerrado',
    
    doc_license: 'Licencia de conducir',
    doc_license_desc: 'Licencia clase B válida',
    doc_id_card: 'Documento de identidad',
    doc_id_card_desc: 'DNI o pasaporte válido',
    doc_residence: 'Comprobante de domicilio',
    doc_residence_desc: 'Factura o certificado de menos de 3 meses',
    doc_insurance: 'Seguro de transporte',
    doc_insurance_desc: 'Seguro que cubre el transporte',
    doc_status_missing: 'No proporcionado',
    doc_status_pending: 'Pendiente',
    doc_status_approved: 'Aprobado',
    doc_status_rejected: 'Rechazado',
    doc_upload: 'Subir',
    doc_view: 'Ver',
    doc_approve: 'Aprobar',
    doc_reject: 'Rechazar',
    
    bank_iban: 'IBAN',
    bank_bic: 'BIC/SWIFT',
    bank_holder: 'Titular de la cuenta',
    bank_name: 'Nombre del banco',
    bank_save: 'Guardar',
    bank_saved: 'Datos guardados',
    
    admin_dashboard: 'Panel de Administración',
    admin_drivers: 'Conductores',
    admin_missions: 'Misiones',
    admin_disputes: 'Disputas',
    admin_payouts: 'Pagos',
    admin_settings: 'Configuración',
    admin_support: 'Soporte',
    admin_verify_driver: 'Verificar conductor',
    admin_reject_driver: 'Rechazar',
    admin_close_dispute: 'Cerrar disputa',
    admin_commission_rate: 'Tasa de comisión',
    admin_pending_verification: 'Pendiente de verificación',
    admin_verified: 'Verificados',
    admin_all: 'Todos',
    admin_payout_process: 'Procesar pago',
    admin_payout_processed: 'Pago procesado',
    admin_view_documents: 'Ver documentos',
    
    chat_send: 'Enviar',
    chat_placeholder: 'Escriba su mensaje...',
    chat_no_messages: 'Sin mensajes',
    chat_with_driver: 'Chat con el conductor',
    chat_with_client: 'Chat con el cliente',
    
    tracking_live: 'Seguimiento en vivo',
    tracking_driver_location: 'Ubicación del conductor',
    tracking_not_available: 'Seguimiento no disponible',
    
    action_save: 'Guardar',
    action_cancel: 'Cancelar',
    action_confirm: 'Confirmar',
    action_delete: 'Eliminar',
    action_edit: 'Editar',
    action_view: 'Ver',
    action_download: 'Descargar',
    action_refresh: 'Actualizar',
    action_search: 'Buscar',
    action_filter: 'Filtrar',
    action_close: 'Cerrar',
    action_back: 'Atrás',
    action_next: 'Siguiente',
    action_previous: 'Anterior',
    
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    yes: 'Sí',
    no: 'No',
    or: 'o',
    and: 'y',
    all: 'Todos',
    none: 'Ninguno',
    total: 'Total',
    date: 'Fecha',
    time: 'Hora',
    status: 'Estado',
    details: 'Detalles',
    currency: 'Moneda',
    amount: 'Monto',
    
    notif_new_offer: 'Nueva oferta recibida',
    notif_offer_accepted: 'Su oferta ha sido aceptada',
    notif_payment_received: 'Pago recibido',
    notif_mission_delivered: 'Misión entregada',
    notif_mission_completed: 'Misión completada',
    
    // Dashboard specific
    client_dashboard: 'Panel del Cliente',
    driver_dashboard: 'Panel del Conductor',
    active_missions: 'Misiones activas',
    waiting_payment: 'Esperando pago',
    ready_to_start: 'Listo para partir',
    waiting_validation: 'Esperando validación del cliente',
    mission_completed_label: 'Misión completada',
    new_driver: 'Nuevo conductor',
    accept_offer: 'Aceptar esta oferta',
    no_offers_yet: 'Sin ofertas por el momento',
    offers_received: 'Ofertas recibidas',
    confirm_reception: 'Confirmar recepción',
    report_problem: 'Reportar un problema',
    already_rated_label: 'Calificado',
    rate_driver_title: 'Calificar al conductor',
    share_experience: 'Comparta su experiencia...',
    open_dispute: 'Abrir disputa',
    dispute_warning: 'Abrir una disputa suspende el pago al conductor.',
    your_proposal: 'Su propuesta',
    send_proposal: 'Enviar mi propuesta',
    verify_documents: 'Verifique sus documentos',
    complete_documents: 'Complete sus documentos para postular',
    proposal_sent: 'Propuesta enviada',
    client_reviewing: 'El cliente está revisando su oferta',
    commission_info: 'de comisión será deducido de su pago final.',
    example: 'Ejemplo',
    you_receive: 'recibirá',
    search_missions: 'Buscar misiones',
    apply_to_missions: 'Postule a misiones disponibles',
    from_you: 'de usted',
    sorted_by_proximity: 'Ordenado por proximidad',
    all_distances: 'Todas las distancias',
    no_missions_found: 'No se encontraron misiones',
    expand_search: 'Intente ampliar sus criterios de búsqueda',
    come_back_later: 'Vuelva más tarde',
    clear_filters: 'Limpiar filtros',
    my_position: 'Mi posición',
    position_active: 'Posición activa',
    max_distance: 'Distancia máxima',
    to_complete: 'Para completar',
    account_not_verified: 'Cuenta no verificada',
    complete_docs_to_apply: 'Complete sus documentos para postular a misiones.',
    valid: 'Válido',
    pending: 'Pendiente',
    missing: 'Faltante',
    rejected: 'Rechazado',
    replace: 'Reemplazar',
    send: 'Enviar',
    transfers: 'Transferencias',
    receive_transfers: 'Para recibir sus transferencias',
    transfer_history: 'Historial de transferencias',
    no_transfers: 'Sin transferencias',
    transfers_appear_here: 'Sus transferencias aparecerán aquí después de cada misión pagada',
    transferred: 'Transferido',
    plan_convoy: 'Planificar un convoy',
    fill_details_quote: 'Complete los detalles para obtener un presupuesto instantáneo',
    service_type: 'Tipo de servicio',
    service_vehicle: 'Convoy de vehículos',
    service_merchandise: 'Transporte de mercancías',
    vehicle_convoy: 'Convoy de vehículos',
    vehicle_move_by_driver: 'Transporte de un vehículo por un conductor.',
    merchandise_transport: 'Transporte de mercancías',
    package_shipping: 'Envío de paquetes o carga.',
    
    // Documents
    update: 'Actualizar',
    complete_docs_to_view_missions: 'Complete sus documentos para ver las misiones',
    all_4_docs_required: 'Los 4 documentos (licencia, DNI, justificante de domicilio, seguro) deben estar validados.',
    vehicle_info: 'Información del vehículo',
    select_option: '-- Seleccionar --',
    city_car: 'Auto urbano',
    sedan: 'Sedán',
    suv: 'SUV / 4x4',
    utility: 'Utilitario',
    motorcycle: 'Motocicleta',
    license_plate: 'Matrícula',
    fiscal_hp: 'Caballos fiscales',
    gasoline: 'Gasolina',
    diesel: 'Diésel',
    hybrid: 'Híbrido',
    electric: 'Eléctrico',
    manual: 'Manual',
    automatic: 'Automático',
    vehicle_condition: 'Estado del vehículo',
    vehicle_running: 'Vehículo en funcionamiento',
    vehicle_not_running: 'Vehículo que no funciona (requiere remolque)',
    vehicle_condition_hint: 'Un vehículo que no funciona requerirá transporte en remolque.',
    merchandise_details: 'Detalles de la mercancía',
    weight_kg: 'Peso (kg)',
    dimensions: 'Dimensiones',
    trip_info: 'Información del viaje',
    departure_address: 'Dirección de salida',
    arrival_address: 'Dirección de llegada',
    enter_address: 'Ingrese una dirección',
    distance_km: 'Distancia (km)',
    duration_min: 'Duración (min)',
    recalculate_route: 'Recalcular ruta',
    calculating: 'Calculando...',
    enter_addresses_map: 'Ingrese las direcciones para ver el mapa',
    special_instructions: 'Mensaje / Instrucciones especiales',
    extra_info_driver: 'Información adicional para el conductor...',
    get_quote_create: 'Obtener presupuesto y crear misión',
    route_calculated: 'Ruta calculada',
    messages: 'Mensajes',
    no_messages: 'Sin mensajes',
    start_conversation: 'Inicie la conversación',
    your_message: 'Su mensaje...',
    today: 'Hoy',
    yesterday: 'Ayer',
    client_label: 'Cliente',
    driver_label: 'Conductor',
    technical_support: 'Soporte técnico',
    we_help_you: 'Estamos aquí para ayudarle',
    new_request: 'Nueva solicitud',
    no_tickets: 'Sin tickets',
    create_first_request: 'Cree su primera solicitud',
    category: 'Categoría',
    general: 'General',
    payment: 'Pago',
    mission: 'Misión',
    technical: 'Técnico',
    subject: 'Asunto',
    summarize_request: 'Resuma su solicitud...',
    describe_problem: 'Describa su problema en detalle...',
    ticket_created: 'Ticket creado exitosamente',
    ticket_closed: 'Ticket cerrado',
    your_reply: 'Su respuesta...',
    support_label: 'Soporte',
    live_tracking: 'Seguimiento en vivo',
    on_route: 'en camino',
    tracking_unavailable: 'Seguimiento no disponible',
    retry: 'Reintentar',
    departure: 'Salida',
    arrival: 'Llegada',
    driver_management: 'Gestión de conductores',
    driver_transfers: 'Transferencias a conductores',
    to_transfer: 'Por transferir',
    done: 'Realizado',
    process_transfer: 'Procesar transferencia',
    transfer_done: 'Transferencia marcada como realizada',
    no_drivers: 'Sin conductores',
    no_disputes: 'Sin disputas',
    select_dispute: 'Seleccione una disputa para ver detalles',
    dispute_details: 'Detalles de la disputa',
    reported_on: 'Reportado el',
    reported_by: 'Reportado por',
    role: 'Rol',
    trajectory: 'Trayecto',
    mission_created_on: 'Creada el',
    resolve_dispute: 'Resolver disputa',
    describe_resolution: 'Describa la resolución...',
    mark_resolved: 'Marcar como resuelto',
    close_without_resolution: 'Cerrar sin resolución',
    resolution: 'Resolución',
    dispute_definitively_closed: 'Esta disputa ha sido cerrada definitivamente.',
    close_definitively: 'Cerrar definitivamente',
    select_ticket: 'Seleccione un ticket para ver la conversación',
    uploaded_documents: 'Documentos subidos',
    not_uploaded: 'No subido',
    verify_all_docs: 'Verifique todos los documentos antes de validar al conductor',
    validate_driver: 'Validar conductor',
    driver_verified: 'Conductor verificado',
    pending_verification: 'Pendiente de verificación',
    uploaded_on: 'Subido el',
    not_provided: 'No proporcionado',
  },
  
  it: {
    // Navbar
    nav_home: 'Home',
    nav_how_it_works: 'Come funziona',
    nav_services: 'Servizi',
    nav_contact: 'Contatti',
    nav_login: 'Accedi',
    nav_register: 'Registrati',
    nav_dashboard: 'Dashboard',
    nav_logout: 'Esci',
    
    // Landing Page
    hero_badge: 'Disponibile in Francia, Europa e Nord Africa',
    hero_title_1: 'IL TRASPORTO',
    hero_title_2: 'DI NUOVA GENERAZIONE',
    hero_subtitle: 'La piattaforma SaaS all-in-one per gestire i trasporti di veicoli e merci. Semplice, Sicuro, Istantaneo.',
    hero_cta_quote: 'Richiedi preventivo gratuito',
    hero_cta_driver: 'Diventa Autista',
    
    stats_missions: 'Missioni completate',
    stats_satisfaction: 'Clienti soddisfatti',
    stats_insurance: 'Assicurazione inclusa',
    stats_support: 'Supporto dedicato',
    
    // Dashboard revenue
    dashboard_revenue: 'Entrate',
    dashboard_welcome: 'Benvenuto',
    
    services_title: 'Le Nostre Soluzioni di Trasporto',
    services_subtitle: 'Che sia per un\'auto o merci, abbiamo la soluzione adatta alle vostre esigenze.',
    
    service_vehicle_title: 'TRASPORTO VEICOLI',
    service_vehicle_desc: 'Trasferimento del vostro veicolo da un autista professionista certificato.',
    service_vehicle_feature_1: 'Assicurazione all-risk inclusa',
    service_vehicle_feature_2: 'Rapporto ispezione digitale (PDF)',
    service_vehicle_feature_3: 'Copertura Europa e Maghreb',
    service_vehicle_cta: 'Simula tariffa veicolo',
    
    service_freight_title: 'TRASPORTO MERCI',
    service_freight_desc: 'Logistica completa per le vostre spedizioni in Algeria, Marocco e Tunisia.',
    service_freight_feature_1: 'Gestione doganale semplificata',
    service_freight_feature_2: 'Tempi garantiti e tracciamento live',
    service_freight_feature_3: 'Trasporto sicuro porta a porta',
    service_freight_cta: 'Richiedi preventivo cargo',
    
    feature_title_1: 'GESTISCI TUTTO DAL',
    feature_title_2: 'TUO SPAZIO CLIENTE',
    feature_desc: 'Niente più carta, niente più chiamate infinite. Convoyageos digitalizza il 100% del processo.',
    feature_step_1: 'Preventivo Istantaneo',
    feature_step_1_desc: 'Algoritmo di pricing intelligente.',
    feature_step_2: 'Firma Elettronica',
    feature_step_2_desc: 'Contratti generati e firmati online.',
    feature_step_3: 'Pagamento Sicuro',
    feature_step_3_desc: 'Transazioni protette via Stripe.',
    
    payment_title: 'PAGAMENTO',
    payment_title_2: 'INTERNAZIONALE',
    payment_desc: 'Paga e ricevi pagamenti nella tua valuta locale.',
    
    cta_title_1: 'PRONTO A SPEDIRE IL TUO',
    cta_title_2: 'PRIMO VEICOLO?',
    cta_desc: 'Unisciti a migliaia di clienti soddisfatti.',
    cta_register: 'Crea account gratuito',
    cta_contact: 'Contatta il team',
    
    footer_tagline: 'Il riferimento per il trasporto digitale di veicoli.',
    footer_services: 'Servizi',
    footer_legal: 'Legale',
    footer_contact: 'Contatti',
    footer_cgu: 'Termini di Servizio',
    footer_how_it_works: 'Come funziona',
    footer_privacy: 'Privacy',
    footer_copyright: '© 2026 Convoyageos. Tutti i diritti riservati.',
    
    // Auth
    login_title: 'Accedi',
    login_subtitle: 'Accedi al tuo spazio personale',
    login_email: 'Email',
    login_password: 'Password',
    login_submit: 'Entra',
    login_no_account: 'Non hai un account?',
    login_register_link: 'Crea un account',
    login_forgot_password: 'Password dimenticata?',
    
    register_title: 'Crea un account',
    register_subtitle: 'Unisciti alla community Convoyageos',
    register_full_name: 'Nome completo',
    register_email: 'Email',
    register_phone: 'Telefono',
    register_password: 'Password',
    register_confirm_password: 'Conferma password',
    register_role: 'Sono',
    register_role_client: 'Cliente',
    register_role_client_desc: 'Cerco un trasportatore',
    register_role_driver: 'Autista',
    register_role_driver_desc: 'Offro i miei servizi',
    register_submit: 'Crea il mio account',
    register_have_account: 'Hai già un account?',
    register_login_link: 'Accedi',
    register_terms: 'Creando un account, accetti i nostri',
    register_terms_link: 'Termini di Servizio',
    
    // Email Verification
    verify_title: 'Verifica la tua email',
    verify_subtitle: 'Abbiamo inviato un codice a 6 cifre a',
    verify_code_label: 'Codice di verifica',
    verify_submit: 'Verifica',
    verify_resend: 'Reinvia codice',
    verify_resend_countdown: 'Reinvia tra',
    verify_success: 'Email verificata con successo!',
    verify_error: 'Codice non valido o scaduto',
    
    // Contact
    contact_title: 'CONTATTACI',
    contact_subtitle: 'Una domanda, un preventivo o una richiesta speciale? Il nostro team è qui per aiutarti.',
    contact_info_title: 'I nostri contatti',
    contact_address: 'Indirizzo',
    contact_phone: 'Telefono',
    contact_email: 'Email',
    contact_hours: 'Orari',
    contact_form_title: 'Inviaci un messaggio',
    contact_name: 'Nome completo',
    contact_subject: 'Oggetto',
    contact_subject_quote: 'Richiesta preventivo',
    contact_subject_info: 'Informazioni generali',
    contact_subject_partnership: 'Partnership',
    contact_subject_complaint: 'Reclamo',
    contact_subject_other: 'Altro',
    contact_message: 'Messaggio',
    contact_submit: 'Invia messaggio',
    contact_success: 'Messaggio inviato con successo!',
    contact_success_desc: 'Abbiamo ricevuto il tuo messaggio e risponderemo il prima possibile.',
    
    // Dashboard Common
    dashboard_welcome: 'Benvenuto',
    dashboard_my_missions: 'Le Mie Missioni',
    dashboard_available_missions: 'Missioni Disponibili',
    dashboard_my_bids: 'Le Mie Offerte',
    dashboard_documents: 'Documenti',
    dashboard_bank_details: 'Dati Bancari',
    dashboard_payments: 'Pagamenti',
    dashboard_payment_history: 'Storico Pagamenti',
    dashboard_statistics: 'Statistiche',
    dashboard_support: 'Supporto Tecnico',
    dashboard_profile: 'Profilo',
    dashboard_settings: 'Impostazioni',
    
    // Mission Types & Status
    mission_type_vehicle: 'Veicolo',
    mission_type_freight: 'Merce',
    mission_status_open: 'Aperta',
    mission_status_assigned: 'Assegnata',
    mission_status_paid: 'Pagata',
    mission_status_delivered: 'Consegnata',
    mission_status_completed: 'Completata',
    mission_status_dispute: 'Disputa',
    
    // Mission Details
    mission_title: 'Titolo',
    mission_description: 'Descrizione',
    mission_origin: 'Partenza',
    mission_destination: 'Destinazione',
    mission_departure_date: 'Data partenza',
    mission_departure_time: 'Ora',
    mission_distance: 'Distanza',
    mission_duration: 'Durata',
    mission_price: 'Prezzo',
    mission_published: 'Pubblicato il',
    mission_flexible: 'Flessibile',
    mission_no_missions: 'Nessuna missione',
    mission_create_new: 'Crea una missione',
    mission_view_offers: 'Vedi offerte',
    mission_offers: 'offerte',
    mission_offer: 'offerta',
    
    // All other keys...
    vehicle_brand: 'Marca',
    vehicle_model: 'Modello',
    vehicle_plate: 'Targa',
    vehicle_type: 'Tipo veicolo',
    vehicle_year: 'Anno',
    vehicle_mileage: 'Chilometraggio',
    vehicle_fuel: 'Carburante',
    
    bid_amount: 'Importo proposto',
    bid_message: 'Messaggio',
    bid_submit: 'Invia offerta',
    bid_accept: 'Accetta',
    bid_reject: 'Rifiuta',
    bid_pending: 'In attesa',
    bid_accepted: 'Accettata',
    bid_rejected: 'Rifiutata',
    bid_your_offer: 'La tua offerta',
    bid_driver_rating: 'Valutazione autista',
    my_evaluations: 'Le mie valutazioni',
    bid_verified: 'Verificato',
    bid_insured: 'Assicurato',
    
    pay_now: 'Paga ora',
    pay_amount: 'Importo da pagare',
    payment_success: 'Pagamento riuscito',
    payment_failed: 'Pagamento fallito',
    payment_pending: 'In attesa',
    payment_date: 'Data',
    payment_method: 'Metodo',
    payment_reference: 'Riferimento',
    no_payment_history: 'Nessuno storico pagamenti',
    
    sign_contract: 'Firma contratto',
    sign_delivery: 'Firma consegna',
    signature_client: 'Firma cliente',
    signature_driver: 'Firma autista',
    signature_required: 'Firma richiesta',
    download_contract: 'Scarica contratto',
    contract_ready: 'Contratto pronto',
    
    rate_mission: 'Valuta missione',
    rate_driver: 'Valuta autista',
    rate_client: 'Valuta cliente',
    rating_comment: 'Il tuo commento',
    rating_submit: 'Invia valutazione',
    rating_thank_you: 'Grazie per la tua valutazione!',
    already_rated: 'Già valutato',
    
    dispute_create: 'Segnala un problema',
    dispute_reason: 'Motivo',
    dispute_description: 'Descrizione',
    dispute_submit: 'Invia',
    dispute_open: 'Aperto',
    dispute_resolved: 'Risolto',
    action_actions: 'Azioni',
    action_pay: 'Paga',
    bid_reviews: 'recensioni',
    contract_sign_confirm: 'Confermare la firma del contratto?',
    login_btn: 'Accedi',
    dispute_closed: 'Chiuso',
    
    doc_license: 'Patente di guida',
    doc_license_desc: 'Patente B valida',
    doc_id_card: 'Carta d\'identità',
    doc_id_card_desc: 'CI o passaporto valido',
    doc_residence: 'Prova di residenza',
    doc_residence_desc: 'Bolletta o certificato di meno di 3 mesi',
    doc_insurance: 'Assicurazione trasporto',
    doc_insurance_desc: 'Assicurazione che copre il trasporto',
    doc_status_missing: 'Non fornito',
    doc_status_pending: 'In attesa',
    doc_status_approved: 'Approvato',
    doc_status_rejected: 'Rifiutato',
    doc_upload: 'Carica',
    doc_view: 'Visualizza',
    doc_approve: 'Approva',
    doc_reject: 'Rifiuta',
    
    bank_iban: 'IBAN',
    bank_bic: 'BIC/SWIFT',
    bank_holder: 'Titolare conto',
    bank_name: 'Nome banca',
    bank_save: 'Salva',
    bank_saved: 'Dati salvati',
    
    admin_dashboard: 'Dashboard Admin',
    admin_drivers: 'Autisti',
    admin_missions: 'Missioni',
    admin_disputes: 'Dispute',
    admin_payouts: 'Pagamenti',
    admin_settings: 'Impostazioni',
    admin_support: 'Supporto',
    admin_verify_driver: 'Verifica autista',
    admin_reject_driver: 'Rifiuta',
    admin_close_dispute: 'Chiudi disputa',
    admin_commission_rate: 'Tasso commissione',
    admin_pending_verification: 'In attesa di verifica',
    admin_verified: 'Verificati',
    admin_all: 'Tutti',
    admin_payout_process: 'Elabora pagamento',
    admin_payout_processed: 'Pagamento elaborato',
    admin_view_documents: 'Visualizza documenti',
    
    chat_send: 'Invia',
    chat_placeholder: 'Scrivi il tuo messaggio...',
    chat_no_messages: 'Nessun messaggio',
    chat_with_driver: 'Chat con l\'autista',
    chat_with_client: 'Chat con il cliente',
    
    tracking_live: 'Tracciamento live',
    tracking_driver_location: 'Posizione autista',
    tracking_not_available: 'Tracciamento non disponibile',
    
    action_save: 'Salva',
    action_cancel: 'Annulla',
    action_confirm: 'Conferma',
    action_delete: 'Elimina',
    action_edit: 'Modifica',
    action_view: 'Visualizza',
    action_download: 'Scarica',
    action_refresh: 'Aggiorna',
    action_search: 'Cerca',
    action_filter: 'Filtra',
    action_close: 'Chiudi',
    action_back: 'Indietro',
    action_next: 'Avanti',
    action_previous: 'Precedente',
    
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',
    warning: 'Attenzione',
    info: 'Informazione',
    yes: 'Sì',
    no: 'No',
    or: 'o',
    and: 'e',
    all: 'Tutti',
    none: 'Nessuno',
    total: 'Totale',
    date: 'Data',
    time: 'Ora',
    status: 'Stato',
    details: 'Dettagli',
    currency: 'Valuta',
    amount: 'Importo',
    
    notif_new_offer: 'Nuova offerta ricevuta',
    notif_offer_accepted: 'La tua offerta è stata accettata',
    notif_payment_received: 'Pagamento ricevuto',
    notif_mission_delivered: 'Missione consegnata',
    notif_mission_completed: 'Missione completata',
    
    // Dashboard specific
    client_dashboard: 'Dashboard Cliente',
    driver_dashboard: 'Dashboard Autista',
    active_missions: 'Missioni attive',
    waiting_payment: 'In attesa di pagamento',
    ready_to_start: 'Pronto a partire',
    waiting_validation: 'In attesa di validazione cliente',
    mission_completed_label: 'Missione completata',
    new_driver: 'Nuovo autista',
    accept_offer: 'Accetta questa offerta',
    no_offers_yet: 'Nessuna offerta al momento',
    offers_received: 'Offerte ricevute',
    confirm_reception: 'Conferma ricezione',
    report_problem: 'Segnala un problema',
    already_rated_label: 'Valutato',
    rate_driver_title: 'Valuta l\'autista',
    share_experience: 'Condividi la tua esperienza...',
    open_dispute: 'Apri disputa',
    dispute_warning: 'Aprire una disputa sospende il pagamento all\'autista.',
    your_proposal: 'La tua proposta',
    send_proposal: 'Invia la mia proposta',
    verify_documents: 'Verifica i tuoi documenti',
    complete_documents: 'Completa i documenti per candidarti',
    proposal_sent: 'Proposta inviata',
    client_reviewing: 'Il cliente sta esaminando la tua offerta',
    commission_info: 'di commissione sarà dedotto dal pagamento finale.',
    example: 'Esempio',
    you_receive: 'riceverai',
    search_missions: 'Cerca missioni',
    apply_to_missions: 'Candidati per missioni disponibili',
    from_you: 'da te',
    sorted_by_proximity: 'Ordinato per vicinanza',
    all_distances: 'Tutte le distanze',
    no_missions_found: 'Nessuna missione trovata',
    expand_search: 'Prova ad ampliare i criteri di ricerca',
    come_back_later: 'Torna più tardi',
    clear_filters: 'Pulisci filtri',
    my_position: 'La mia posizione',
    position_active: 'Posizione attiva',
    max_distance: 'Distanza massima',
    to_complete: 'Da completare',
    account_not_verified: 'Account non verificato',
    complete_docs_to_apply: 'Completa i documenti per candidarti alle missioni.',
    valid: 'Valido',
    pending: 'In attesa',
    missing: 'Mancante',
    rejected: 'Rifiutato',
    replace: 'Sostituisci',
    send: 'Invia',
    transfers: 'Trasferimenti',
    receive_transfers: 'Per ricevere i tuoi trasferimenti',
    transfer_history: 'Storico trasferimenti',
    no_transfers: 'Nessun trasferimento',
    transfers_appear_here: 'I tuoi trasferimenti appariranno qui dopo ogni missione pagata',
    transferred: 'Trasferito',
    plan_convoy: 'Pianifica un convoglio',
    fill_details_quote: 'Compila i dettagli per ottenere un preventivo istantaneo',
    service_type: 'Tipo di servizio',
    service_vehicle: 'Convoglio veicolo',
    service_merchandise: 'Trasporto merci',
    vehicle_convoy: 'Convoglio veicolo',
    vehicle_move_by_driver: 'Trasporto veicolo da un autista.',
    merchandise_transport: 'Trasporto merci',
    package_shipping: 'Spedizione pacchi o merci.',
    
    // Documents
    update: 'Aggiornare',
    complete_docs_to_view_missions: 'Completa i tuoi documenti per visualizzare le missioni',
    all_4_docs_required: 'Tutti i 4 documenti (patente, carta d\'identità, prova di residenza, assicurazione) devono essere convalidati.',
    vehicle_info: 'Informazioni veicolo',
    select_option: '-- Seleziona --',
    city_car: 'Utilitaria',
    sedan: 'Berlina',
    suv: 'SUV / 4x4',
    utility: 'Furgone',
    motorcycle: 'Moto',
    license_plate: 'Targa',
    fiscal_hp: 'Cavalli fiscali',
    gasoline: 'Benzina',
    diesel: 'Diesel',
    hybrid: 'Ibrido',
    electric: 'Elettrico',
    manual: 'Manuale',
    automatic: 'Automatico',
    vehicle_condition: 'Condizione del veicolo',
    vehicle_running: 'Veicolo funzionante',
    vehicle_not_running: 'Veicolo non funzionante (rimorchio necessario)',
    vehicle_condition_hint: 'Un veicolo non funzionante richiederà il trasporto su rimorchio.',
    merchandise_details: 'Dettagli merce',
    weight_kg: 'Peso (kg)',
    dimensions: 'Dimensioni',
    trip_info: 'Informazioni viaggio',
    departure_address: 'Indirizzo di partenza',
    arrival_address: 'Indirizzo di arrivo',
    enter_address: 'Inserisci un indirizzo',
    distance_km: 'Distanza (km)',
    duration_min: 'Durata (min)',
    recalculate_route: 'Ricalcola percorso',
    calculating: 'Calcolo in corso...',
    enter_addresses_map: 'Inserisci gli indirizzi per vedere la mappa',
    special_instructions: 'Messaggio / Istruzioni speciali',
    extra_info_driver: 'Informazioni aggiuntive per l\'autista...',
    get_quote_create: 'Ottieni preventivo e crea missione',
    route_calculated: 'Percorso calcolato',
    messages: 'Messaggi',
    no_messages: 'Nessun messaggio',
    start_conversation: 'Inizia la conversazione',
    your_message: 'Il tuo messaggio...',
    today: 'Oggi',
    yesterday: 'Ieri',
    client_label: 'Cliente',
    driver_label: 'Autista',
    technical_support: 'Supporto tecnico',
    we_help_you: 'Siamo qui per aiutarti',
    new_request: 'Nuova richiesta',
    no_tickets: 'Nessun ticket',
    create_first_request: 'Crea la tua prima richiesta',
    category: 'Categoria',
    general: 'Generale',
    payment: 'Pagamento',
    mission: 'Missione',
    technical: 'Tecnico',
    subject: 'Oggetto',
    summarize_request: 'Riassumi la tua richiesta...',
    describe_problem: 'Descrivi il problema in dettaglio...',
    ticket_created: 'Ticket creato con successo',
    ticket_closed: 'Ticket chiuso',
    your_reply: 'La tua risposta...',
    support_label: 'Supporto',
    live_tracking: 'Tracciamento in tempo reale',
    on_route: 'in viaggio',
    tracking_unavailable: 'Tracciamento non disponibile',
    retry: 'Riprova',
    departure: 'Partenza',
    arrival: 'Arrivo',
    driver_management: 'Gestione autisti',
    driver_transfers: 'Trasferimenti autisti',
    to_transfer: 'Da trasferire',
    done: 'Fatto',
    process_transfer: 'Elabora trasferimento',
    transfer_done: 'Trasferimento segnato come completato',
    no_drivers: 'Nessun autista',
    no_disputes: 'Nessuna disputa',
    select_dispute: 'Seleziona una disputa per vedere i dettagli',
    dispute_details: 'Dettagli disputa',
    reported_on: 'Segnalato il',
    reported_by: 'Segnalato da',
    role: 'Ruolo',
    trajectory: 'Traiettoria',
    mission_created_on: 'Creata il',
    resolve_dispute: 'Risolvi disputa',
    describe_resolution: 'Descrivi la risoluzione...',
    mark_resolved: 'Segna come risolto',
    close_without_resolution: 'Chiudi senza risoluzione',
    resolution: 'Risoluzione',
    dispute_definitively_closed: 'Questa disputa è stata chiusa definitivamente.',
    close_definitively: 'Chiudi definitivamente',
    select_ticket: 'Seleziona un ticket per vedere la conversazione',
    uploaded_documents: 'Documenti caricati',
    not_uploaded: 'Non caricato',
    verify_all_docs: 'Verifica tutti i documenti prima di validare l\'autista',
    validate_driver: 'Valida autista',
    driver_verified: 'Autista verificato',
    pending_verification: 'In attesa di verifica',
    uploaded_on: 'Caricato il',
    not_provided: 'Non fornito',
  },
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const validLanguageCodes = ['fr', 'en', 'ar', 'es', 'it'];

  const [language, setLanguage] = useState(() => {
    const queryLang = new URLSearchParams(window.location.search).get('lang');
    if (queryLang && validLanguageCodes.includes(queryLang)) {
      return queryLang;
    }

    const saved = localStorage.getItem('preferred_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('preferred_language', language);
    // Set document direction for RTL languages (Arabic)
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['fr'][key] || key;
  };

  const availableLanguages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  ];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, availableLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
